import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import * as XLSX from 'xlsx';
import appSettings from './app_settings';

import {
    BUTTON_LINKS,
    LEAD_SHEET_NOTICE,
    LEAD_SHEET_TEMPLATES_URL,
    NEW_TO_CORP_REPORTING,
    CORP_REPORTING_GUIDE_URL,
    mandatoryFields
} from './FlexicoConstants';

import { alias_dropdown, CRA_STATUS, TEMPLATE_DOWNLOAD_URL, BULK_UPLOAD_EXPECTED_HEADERS } from './Constants';

import {
    AppLayout, HelpPanel, Cards, Tabs, Icon, Spinner, ContentLayout, Table,
    Container, Header, Box, Pagination, SpaceBetween, ExpandableSection, Modal, ColumnLayout, Button, Badge, Textarea, Select, Alert, Input, TokenGroup, DatePicker, TimeInput,
    Checkbox, Flashbar, FileInput, StatusIndicator, Grid, ButtonDropdown, Multiselect,
    RadioGroup,
    ButtonGroup,
    SegmentedControl, Link
} from '@amzn/awsui-components-react';
import { v4 as uuidv4 } from 'uuid';
import '../../index.scss';
import { useSelector, useDispatch } from 'react-redux'

import './styles.scss'

import { useHistory } from 'react-router-dom';

import SideNav from './SideNav';
import { createAuditLog, resetProcessStatus, updateProcessLite } from '../Templates/Utils/AppActivityUtils';
import { useSuggestedLogins } from 'src/hooks/useSuggestedLogins';
import { APPROVER_TYPES, PROCESS_KEYS, UPLOADER_TYPES } from '../Frisco/Constants';
import { getEditableFields } from "../Templates/Utils/FormMetadata";
import { isCorpAdmin } from '../Templates/Utils/Permissions';
import Feedback from 'src/generic-components/UserFeedback/Feedback';

import { getQuarterForUpload, renderStatus, convertToPST, showDueDatesTable, showGenericDatesTable, renderStatusWithLastUpdatedTime, getLatestTrackingDetails, getStatus, getOneWBStatusBasedOnCustomAttributes, getWBStatusBasedOnCustomAttributes, getStatusForMultipleStatus, getCurrentQuarter, validateMandatoryRestrictions } from './Utility';
import { addDefaultSecAlias } from './AliasUtils';
import { setCurrentAppId } from 'src/store/userAuthSlice';
import CustomMultiHybridInputAndSelect from '../Templates/components/CustomMultiHybridInputAndSelect';
import { updateFlexicoTemplate } from 'src/utilities/FlexicoAPIs';
import { FLEXICO_TEMPLATE_KEYS } from '../FlexiCo/Constants';
import FlexicoConfig from './FlexicoConfig';
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import ApprovalsHome from 'src/Approvals/approvalsHome';
import { createPreference, listPreference, listServicesWithTracksForQuarter, updatePreference, corpReportingCanViewAliases, getAppDeliverablesLockStatus } from 'src/utilities/AppSyncPlusAPIs';
import { getCachedLdaps, isMemberOf } from 'src/checkPageAccess';
import { updateIntervalFlexiCoTrackingStatus, updateIntervalFRISCOTrackingStatus } from '../Templates/Utils/AppActivityUtilsAppsyncPlus';
import { getApproverWasWorkflows } from 'src/utilities/wasApprovalAPIs';
import { getFriscoGroupsForAppId } from '../Templates/Utils/AppActivityUtils';
import craLogo from '../../images/cra_logo.png'


// Component ServiceHomepage is a skeleton of a service's homepage using AWS-UI React components.
export default (props) => {
    const history = useHistory()
    const dispatch = useDispatch();
    const gridRef = useRef();
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)
    const userId = useSelector((globalState) => globalState.auth.userId);
    const userLDAPS = useSelector((globalState) => globalState.auth.userLDAPS);
    const isCorpReportingAdmin = useSelector((globalState)=>globalState.auth.isCorpReportingAdmin)
    const [NavOpen, setNavOpen] = useState(false);
    const [groupName, setGroupName] = useState("");
    const [filteringText, setFilteringText] = useState("");
    const [filteringTextCRDeliverable, setFilteringTextCRDeliverable] = useState("");

    const [showDeliverablesLoader, setShowDeliverablesLoader] = useState(true);

    const [showDeliverablesLoaderMain, setShowDeliverablesLoaderMain] = useState('');
    const [deliverables, setDeliverables] = useState([]);
    const [deliverablesForAlias, setDeliverablesForAlias] = useState([]);

    const [accessMap, setAccessMap] = useState({})
    const isAdmin = useRef(false)
    const [configurationWindowContent, setConfigurationWindowContent] = useState(null);
    const [configurationWindowContentOriginal, setConfigurationWindowContentOriginal] = useState(null);

    const [resetLoadingMessage, setResetLoadingMessage] = useState(null)
    const [dueDatePickerValue, setDueDatePickerValue] = useState("")
    const [windowContentLoadingMessage, setWindowContentLoadingMessage] = useState(null)
    const [windowContentLoadingError, setWindowContentLoadingError] = useState(null)
    const [fieldMetadata, setFieldMetadata] = useState({});
    const { suggestedLogins, aliasesLoading, getSuggestedLoginsCaller } = useSuggestedLogins();

    const [showUploadDeliverablesDueDateModal, setShowUploadDeliverablesDueDateModal] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const [successMessage, setSuccessMessage] = useState('');
    const [quickFilterText, setQuickFilterText] = useState(null)
    const [quickFilterId, setQuickFilterId] = useState('all')
    const [flexicoConfig, setFlexicoConfig] = useState(null)
    const [bulkErrorsCount, setBulkErrorsCount] = useState(0);
    const [adminStatusEditContentModal, setAdminStatusEditContentModal] = useState(null);
    const [adminStatusEditContentModalLoader, setAdminStatusEditContentModalLoader] = useState(null);
    const [selectedAlias, setSelectedAlias] = useState({ label: "All", value: null });
    const [selectedWorkstream, setSelectedWorkstream] = useState({ label: "All", value: null });
    const [workstreamOptions, setWorkstreamOptions] = useState([]);
    const [expandedState, setExpandedState] = useState({});
    const deliverableMapper = useRef({})
    const [isUploadBtnEnabled, setIsUploadBtnEnabled] = useState(false);
    const [fileError, setFileError] = useState('');
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [fileName, setFileName] = useState('');
    const [hasViewChanged, setHasViewChanged] = useState(false);
    const [gridViewPreference, setGridViewPreference] = useState({});
    const [preferenceButtonLoaderMessage, setPreferenceButtonLoaderMessage] = useState(false);
    const [aliasOptions, setAliasOptions] = useState([]);
    const [isDeliverablesLocked, setIsDeliverablesLocked] = useState(false)

    const overallStatusOptions = [{ 'label': 'COMPLETED', 'value': 'COMPLETED' }, { 'label': 'INCOMPLETE', 'value': 'INCOMPLETE' }]
    const friscoStatusOptions = {
        'PreWB': [
            { 'label': 'No action required', 'value': 'No action required' },
            ...Object.values(CRA_STATUS).filter(status => status !== CRA_STATUS.NO_POST_WB).map(status => ({
                label: status,
                value: status
            }))
        ],
        'PostWB': [
            { 'label': 'No action required', 'value': 'No action required' },
            ...Object.values(CRA_STATUS).filter(status => status !== CRA_STATUS.NO_PRE_WB).map(status => ({
                label: status,
                value: status
            }))
        ]
    }

    const flexicoStatusOptions = {
        'PreWB': [
            { 'label': 'No action required', 'value': 'No action required' },
            ...Object.values(CRA_STATUS).filter(status => status !== CRA_STATUS.NO_POST_WB).map(status => ({
                label: status,
                value: status
            }))
        ],
        'PostWB': [
            { 'label': 'No action required', 'value': 'No action required' },
            ...Object.values(CRA_STATUS).filter(status => status !== CRA_STATUS.NO_PRE_WB).map(status => ({
                label: status,
                value: status
            }))
        ]
    }

    const [allDeliverablesCount, setAllDeliverablesCount] = useState(0);
    const [notDueCount, setNotDueCount] = useState(0);
    const [dueTodayCount, setDueTodayCount] = useState(0);
    const [overdueCount, setOverdueCount] = useState(0);
    const [pendingApprovalCount, setPendingApprovalCount] = useState(0);

    // Dynamic deliverables state
    const [dynamicDeliverables, setDynamicDeliverables] = useState([]);
    const due_date_keys = {
        'PRE_WB_DUE_DATE': {
            ui_keys: {
                due_date: 'due_date',
                due_time: 'due_time',
                due_date_flexico: 'preDueDate',
                no_wb_due_date: 'no_pre_wb_due_date',
                no_wb_due_date_v2: 'noPreDueDate'
            },
            no_due_attribute_type: 'NO_PRE_WB_DUE_DATE'
        },
        'POST_WB_DUE_DATE': {
            ui_keys: {
                due_date: 'post_wb_due_date',
                due_time: 'post_wb_due_time',
                due_date_flexico: 'postDueDate',
                no_wb_due_date: 'no_post_wb_due_date',
                no_wb_due_date_v2: 'noPostDueDate'
            },
            no_due_attribute_type: 'NO_POST_WB_DUE_DATE'
        },
        'PRE_TAX_DATE': {
            ui_keys: {
                due_date: 'pre_tax_date',
                due_time: 'pre_tax_time',
                due_date_flexico: 'preTaxDate',
                no_wb_due_date: 'no_pre_tax_date',
                no_wb_due_date_v2: 'noPreTax'
            },
            no_due_attribute_type: 'NO_PRE_TAX_DATE'
        },
        'POST_TAX_DATE': {
            ui_keys: {
                due_date: 'post_tax_date',
                due_time: 'post_tax_time',
                due_date_flexico: 'postTaxDate',
                no_wb_due_date: 'no_post_tax_date',
                no_wb_due_date_v2: 'noPostTax'
            },
            no_due_attribute_type: 'NO_POST_TAX_DATE'
        }
    }

    // Functions to manage dynamic deliverables
    const addDeliverable = () => {
        const newId = `deliverable_${Date.now()}`;
        const newDeliverable = {
            id: newId,
            label: '',
            placeholder: 'REF1.1',
            alias_type: newId.toUpperCase()
        };
        setDynamicDeliverables([...dynamicDeliverables, newDeliverable]);
    };

    const removeDeliverable = (id) => {
        if (dynamicDeliverables.length > 1) {
            setDynamicDeliverables(dynamicDeliverables.filter(deliverable => deliverable.id !== id));
            // Also clear the corresponding configuration data
            if (configurationWindowContent) {
                const updated = { ...configurationWindowContent };
                delete updated[`${id}_deliverable_enabled`];
                delete updated[`${id}_deliverable`];
                setConfigurationWindowContent(updated);
            }
        }
    };

    const updateDeliverableLabel = (id, newLabel) => {
        setDynamicDeliverables(dynamicDeliverables.map(deliverable =>
            deliverable.id === id ? { ...deliverable, label: newLabel } : deliverable
        ));
    };

    const defaultColDef = {
        // set filtering on for all columns
        filter: true,
        filterParams: {
            buttons: ["reset"],
            debounceMs: 200,
        }
    };

    useEffect(() => {
        dispatch(setCurrentAppId(appSettings[currentStage].appId));
        // updatePendingApprovals();
        return () => {
            // this now gets called when the component unmounts
        };
    }, [currentStage]);


    useEffect(() => {
        let filteredByName = []
        for (let i = 0; i < deliverablesForAlias.length; i++) {
            if (
                deliverablesForAlias[i].process_name?.toLowerCase().includes(filteringText.toLowerCase()) ||
                deliverablesForAlias[i].process_id?.toLowerCase().includes(filteringText.toLowerCase()) ||
                deliverablesForAlias[i].overall_status?.toLowerCase().includes(filteringText.toLowerCase())
            ) {
                filteredByName.push(deliverablesForAlias[i])
            }
        }
        return () => {
            // this now gets called when the component unmounts
        };
    }, [filteringText, deliverablesForAlias]);


    useEffect(() => {
        onFilterTextBoxChanged()
        return () => {
            // this now gets called when the component unmounts
        };
    }, [quickFilterText]);

    useEffect(() => {
        // Reload data with the selected alias
        setViews()
    }, [selectedAlias])

    useEffect(() => {
        // Set workstream when opening modal if workstreams are loaded and configuration content exists
        if (configurationWindowContent && configurationWindowContent.group_id && workstreamOptions.length > 0) {
            const matchingWorkstream = workstreamOptions.find(option => option.value === configurationWindowContent.group_id);
            if (matchingWorkstream && selectedWorkstream.value !== matchingWorkstream.value) {
                setSelectedWorkstream(matchingWorkstream);
            }
        } else if (configurationWindowContent && !configurationWindowContent.group_id && workstreamOptions.length > 0) {
            setSelectedWorkstream(null);
        }
    }, [workstreamOptions, configurationWindowContent])

    const loadWorkstreams = () => {
        getFriscoGroupsForAppId(appSettings[currentStage].appId, function onSuccess(result) {
            const workstreams = result.data.getFRISCOGroups.map(group => ({
                label: group.group_name,
                value: group.group_id
            }));
            setWorkstreamOptions(workstreams);
        }, function onFailure(result) {
            console.error('Failed to load workstreams:', result);
        });
    }

    const updatePendingApprovals = async () => {
        const pendingApproverDetails = {
            userAliasAllStates: userId,
            stage: currentStage,
            userResponseStatus: "PENDING",
            workflowStatus: "pending"
        }
        const res2 = await getApproverWasWorkflows(pendingApproverDetails)
        setPendingApprovalCount(res2['metaData']['totalItems'])
    }

    const loadAliasOptions = () => {
        // If admin, show all options without API call
        if (isAdmin.current) {
            const allOptions = alias_dropdown[currentStage] || [];
            setAliasOptions(allOptions);
            return;
        }
        
        corpReportingCanViewAliases(currentStage, function onSuccess(result) {
            try {
                const aliasData = JSON.parse(result.data.getCorpReportingAliases);
                const authorizedIds = aliasData
                    .filter(item => item.is_authorised === true)
                    .map(item => item.owner_id.toString());
                
                const formattedOptions = (alias_dropdown[currentStage] || [])
                    .filter(option => authorizedIds.includes(option.value));
                
                setAliasOptions(formattedOptions);
                
                // Set default selection if not admin and options available
                if (formattedOptions.length > 0 && selectedAlias.value === null) {
                    setSelectedAlias(formattedOptions[0]);
                }
            } catch (error) {
                console.error('Failed to parse alias data:', error);
                setAliasOptions([]);
            }
        }, function onFailure(result) {
            console.error('Failed to load alias options:', result);
            setAliasOptions([]);
        });
    }

    const setViews = async () => {
        loadEditableFields()
        // checking from redux if corp reporting admin == true. else, fallback to existing approach
        if(isCorpReportingAdmin){
            isAdmin.current = isCorpReportingAdmin
        }else{
            let accessPerms = await isCorpAdmin(userId, appSettings[currentStage].appId, currentStage)
            isAdmin.current = accessPerms?.admin
        }
        loadAliasOptions();
        loadAllServicesWithTracksForQuarter(appSettings[currentStage].appId)
        loadWorkstreams();
        getAppDeliverablesLockStatus(appSettings[currentStage].appId,
            (result) => setIsDeliverablesLocked(result?.data?.getAppDeliverablesLockStatus?.is_locked ?? false),
            () => {}
        )
    }

    useEffect(() => {
        quickFilter(quickFilterId);
        gridRef?.current?.api?.onFilterChanged();
    }, [quickFilterId]);

    const getQuarter = () => {
        return getQuarterForUpload()

    }
    const  getDeliverableMapperKey = (data) => {
        let key=''
        if (data?.process_id) {
            key = `FRISCO_${data.process_id}`
        } else if (data?.flex_id) {
            key = `FLEXICO_${data.flex_id}`
        }
        return key || null
    }

    function getTagForDeliverable(data){
        if(data == null){
            return null
        }
       let key = getDeliverableMapperKey(data);
        return deliverableMapper.current?.[key] || null
    }

    function filterDisabledDeliverables(deliverables){
        if (!deliverables || !Array.isArray(deliverables)) {
            return deliverables;
        }
        
        let filteredDeliverables = [];
        for(let i=0; i<deliverables.length; i++){
            let deliverable = deliverables[i];
            let key = getDeliverableMapperKey(deliverable);
            
            // Check if the key exists in deliverableMapper and if disabled is true
            if (key && deliverableMapper.current && deliverableMapper.current[key] && deliverableMapper.current[key].disabled === true) {
                continue; // Skip this deliverable
            }
            
            // Add to filtered list if not disabled
            filteredDeliverables.push(deliverable);
        }
        return filteredDeliverables;
    }

    function cacheDeliverableFilterTags(deliverables){
        let mapper = {}
        for(let i=0;i<deliverables?.length;i++){
            let deliverable = deliverables[i]
            let key = null
            if(deliverable?.process_id){
                // FRISCO
                key = getDeliverableMapperKey(deliverable)
                mapper[key] = {'showTags':[], 'filterOnlyTags': [], 'wbInfo': {}}
                if(deliverable?.environment == "Transfer_S3_Workdocs"){
                    mapper[key]['showTags'].push('to Workdocs')
                }else if(deliverable?.environment == "Transfer_FAST_RedShift"){
                    mapper[key]['showTags'].push('to Workiva')
                }
            }else if(deliverable?.flex_id){
                // FLEXICO
                key = getDeliverableMapperKey(deliverable)
                mapper[key] = {'showTags':[], 'filterOnlyTags': [], 'wbInfo': {}}
                mapper[key]['showTags'].push('Automated')
            }
            if(key == null){
                continue
            }
            // add custom attributes
            mapper[key]['cadence'] = getCadenceAttribute(deliverable?.custom_attributes)
            if(isAnnualOnlyDeliverable(mapper[key]['cadence'])){
                mapper[key]['filterOnlyTags'].push('Annual only')
            }else if(isAnnualDeliverable(mapper[key]['cadence'])){
                mapper[key]['filterOnlyTags'].push('Annual')
            }else if(isQuarterlyDeliverable(mapper[key]['cadence'])){
                mapper[key]['filterOnlyTags'].push('Quarterly')
            }
            mapper[key]['disabled'] = (deliverable?.custom_attributes?.find(attr => attr.attribute_type === "DISABLED")?.attribute || "false") === "true"
            if(mapper[key]['disabled']){
                mapper[key]['filterOnlyTags'].push('disabled')
            }
            mapper[key]['wbInfo']['noPreWBDueDate'] = deliverable?.custom_attributes?.find(attr => attr.attribute_type === due_date_keys['PRE_WB_DUE_DATE']['no_due_attribute_type'])?.attribute || null;
            mapper[key]['wbInfo']['noPostWBDueDate'] = deliverable?.custom_attributes?.find(attr => attr.attribute_type === due_date_keys['POST_WB_DUE_DATE']['no_due_attribute_type'])?.attribute || null;
        }
        deliverableMapper.current = mapper
    }

    function isAnnualDeliverable(cadence){
        return ['ANNUALLY', 'BOTH'].includes(cadence)
    }

    function isAnnualOnlyDeliverable(cadence){
        return ['ANNUALLY'].includes(cadence)
    }

    function isQuarterlyDeliverable(cadence){
        return ['QUARTERLY', 'BOTH', '', null].includes(cadence)
    }

    const loadAllServicesWithTracksForQuarter = (appId) => {
        setShowDeliverablesLoader(true)
        var quarterValue = getQuarter()

        listServicesWithTracksForQuarter(appId, selectedAlias?.value, quarterValue, function onSuccess(result) {
            let deliverables = JSON.parse(result.data.listServicesWithTracksForQuarter)
            deliverables = deliverables.sort((a, b) => {
                if (a.group_name < b.group_name) {
                    return -1;
                }
            });
            setDeliverables(deliverables)
            // map the disabled and quartery tags in one iteration - to reduce the lookup on render
            cacheDeliverableFilterTags(deliverables)
            if(!isAdmin.current){
                deliverables = filterDisabledDeliverables(deliverables)
            }
            setDeliverables(deliverables)
            setShowDeliverablesLoader(false)
        }, function onFailure(result) {
        })

    }

    useEffect(() => {
        
        if (gridRef?.current?.api && Object.keys(expandedState).length > 0) {
            gridRef?.current?.api?.forEachNode(node => {
                if (node.group && expandedState[node.id] !== undefined) {
                    node.setExpanded(expandedState[node.id]);
                }
            });
        }

        const activeDeliverables = deliverables.filter(item => !getTagForDeliverable(item)?.disabled);
        setAllDeliverablesCount(activeDeliverables.length);
        let dueToday = 0;
        let overdue = 0;
        let notDue = 0;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        activeDeliverables.forEach((item) => {
            const dueDatesData = getDueDates(item);
            const preWBDate = getPstDate(dueDatesData.due_date, dueDatesData.due_time)?.setHours(0, 0, 0, 0);
            const postWBDate = getPstDate(dueDatesData.post_wb_due_date, dueDatesData.post_wb_due_time)?.setHours(0, 0, 0, 0);
            const preWBStatus = getStatus(item, getOneWBStatusBasedOnCustomAttributes(item, 'PreWB'))?.overall_status;
            const postWBStatus = getStatus(item, getOneWBStatusBasedOnCustomAttributes(item, 'PostWB'))?.overall_status;

            const preOverdue = preWBDate && preWBDate < today.getTime() && preWBStatus !== 'COMPLETE';
            const postOverdue = postWBDate && postWBDate < today.getTime() && postWBStatus !== 'COMPLETE';
            const preDueToday = preWBDate === today.getTime() && preWBStatus !== 'COMPLETE';
            const postDueToday = postWBDate === today.getTime() && postWBStatus !== 'COMPLETE';
            const preNotDue = preWBDate && preWBDate > today.getTime() && preWBStatus !== 'COMPLETE';
            const postNotDue = postWBDate && postWBDate > today.getTime() && postWBStatus !== 'COMPLETE';

            if (preOverdue || postOverdue) {
                overdue++;
            } else if (preDueToday || postDueToday) {
                dueToday++;
            } else if (preNotDue || postNotDue) {
                notDue++;
            }
        });

        setDueTodayCount(dueToday);
        setOverdueCount(overdue);
        setNotDueCount(notDue);
    }, [deliverables]);

    const getAliases = (item, key, individualType, groupType, index) => {
        let individualAliases = [];
        let groupAliases = [];
        if (!item?.hasOwnProperty(key)) {
            return {}
        }
        item[key]?.sort((a, b) => (a.column_index > b.column_index ? 1 : -1));
        if (item[key]) {
            for (let eachItem of item[key]) {
                if (eachItem?.column_index != index) {
                    continue;
                }
                if (eachItem['type'] === individualType) {
                    individualAliases.push(eachItem['alias']);
                } else if (eachItem['type'] === groupType) {
                    groupAliases.push(eachItem['alias']);
                }
            }
        }
        return { 'USER': individualAliases || [], 'LDAP': groupAliases || [] }
    }

    const renderAliases = (aliases) => {
        let resp = <Box>
            <Box>
                {aliases['USER'] && aliases['USER'].length > 0
                    ? <span className="small_values">{aliases['USER'].join(', ')}</span>
                    : ''
                }
            </Box>

            <Box>
                {aliases['LDAP'] && aliases['LDAP'].length > 0
                    ? <span className="small_values">{aliases['LDAP'].join(', ')}</span>
                    : ''
                }
            </Box>
        </Box>
        return resp
    }

    const flattenAliases = (aliases) => {
        return Object.values(aliases || {}).flat();
    }

    const resetStatus = (item) => {
        setResetLoadingMessage("Resetting ..")
        var quarterValue = getQuarter()
        createAuditLog(`FRISCO#${item[PROCESS_KEYS.process_id]}`, `${getCurrentTime()}`, "Reset process via control panel", JSON.stringify(item), JSON.stringify(item), "RESET REQ", userId)
        resetProcessStatus(item[PROCESS_KEYS.process_id], quarterValue, ["PreWB", "PostWB", "NoPostWB", "NoPreWB"],
            function onSuccess(result) {
                setResetLoadingMessage(JSON.parse(result?.data.resetProcessStatus)?.message)
                loadAllServicesWithTracksForQuarter(appSettings[currentStage].appId)
            },
            function onFailure(result) {
                setResetLoadingMessage("Reset failed")
            })
    }

    const loadEditableFields = async () => {
        let res = await getEditableFields()
        res[PROCESS_KEYS.approvers] = { values: [{ label: "USER", value: APPROVER_TYPES.APPROVER }, { label: "LDAP", value: APPROVER_TYPES.APPROVER_LDAP }] }
        res[PROCESS_KEYS.approvers] = { values: [{ label: "USER", value: APPROVER_TYPES.APPROVER }, { label: "LDAP", value: APPROVER_TYPES.APPROVER_LDAP }] }
        res[PROCESS_KEYS.uploaders] = { values: [{ label: "USER", value: UPLOADER_TYPES.UPLOADER }, { label: "LDAP", value: UPLOADER_TYPES.UPLOADER_LDAP }] }
        setFieldMetadata(res)
    }

    const getValue = (fieldName, subKey = null) => {
        if (subKey) {
            if (configurationWindowContent.hasOwnProperty(fieldName)) {
                return configurationWindowContent?.[fieldName][subKey]
            } else {
                return null
            }
        } else {
            return configurationWindowContent?.[fieldName]
        }

    }

    const postProcessTeamEmails = (value) => {
        return value.replaceAll("@amazon.com", "")
    }

    const approversValidation = (elements) => {
        let emptyValues = true
        elements?.forEach((element) => {
            if (!element.type || !element.alias) {
                emptyValues = false
            }
        })
        return emptyValues
    }

    const stripUniqueItemsAndMerge = (items, newItems, filterCriteria) => {
        let lookup = {}
        let indexes = {}
        let resultItems = []
        newItems.forEach((val) => {
            indexes[val.column_index] = 1
        })
        for (let i = 0; i < items?.length; i++) {
            if (items[i].column_index in indexes) {
                continue
            } else if (items[i].column_index == filterCriteria['column_index']) {
                continue
            }
            else {
                resultItems.push(items[i])
                let hashKey = `${items[i].alias}-${items[i].column_index}-${items[i].type}`
                if (!(hashKey in lookup)) {
                    lookup[hashKey] = 1
                }
            }

        }
        for (let i = 0; i < newItems?.length; i++) {
            let hashKey = `${newItems[i].alias}-${newItems[i].column_index}-${newItems[i].type}`
            if (!(hashKey in lookup)) {
                lookup[hashKey] = 1
                resultItems.push(newItems[i])
            }
        }
        return resultItems
    }

    const updateValue = (fieldName, value, subKey = null, filterCriteria = null) => {
        const updated = { ...configurationWindowContent }
        if (subKey) {
            if (!updated.hasOwnProperty(fieldName)) {
                updated[fieldName] = {}
            }
            updated[fieldName][subKey] = value
        } else {
            if (fieldName == PROCESS_KEYS.approvers) {
                updated[fieldName] = stripUniqueItemsAndMerge(updated[fieldName], value, filterCriteria)
            } else {
                updated[fieldName] = value
            }
        }
        setConfigurationWindowContent(updated)
    }

    const getSelectFieldValues = (fieldName, subKey = null) => {
        if (fieldMetadata && fieldMetadata[fieldName] && fieldMetadata[fieldName]['values']) {
            return fieldMetadata[fieldName]['values']
        } else if (subKey && fieldMetadata && fieldMetadata[fieldName][subKey] && fieldMetadata[fieldName][subKey]['values']) {
            return fieldMetadata[fieldName][subKey]['values']
        } else {
            return []
        }
    }

    function alterIntervalTrackingStatus() {
        setAdminStatusEditContentModalLoader("Updating..")
        if (adminStatusEditContentModal.type == 'FRISCO') {
            updateIntervalFRISCOTrackingStatus(adminStatusEditContentModal.status.tracking_id?.toString(), adminStatusEditContentModal.status.current_status, adminStatusEditContentModal.status.overall_status, function onSuccess(result) {
                loadAllServicesWithTracksForQuarter(appSettings[currentStage].appId)
                setAdminStatusEditContentModalLoader(null)
                resetAdminStatusEditModal()
            }, function onFailure(result) {
                setAdminStatusEditContentModalLoader("Update failed!")
            })
        } else if (adminStatusEditContentModal.type == 'FLEXICO') {
            updateIntervalFlexiCoTrackingStatus(adminStatusEditContentModal.status.tracking_id?.toString(), adminStatusEditContentModal.status.current_status, adminStatusEditContentModal.status.overall_status, function onSuccess(result) {
                loadAllServicesWithTracksForQuarter(appSettings[currentStage].appId)
                setAdminStatusEditContentModalLoader(null)
            }, function onFailure(result) {
                setAdminStatusEditContentModalLoader("Update failed!")
            })
        }
    }

    const resetModal = () => {
        setConfigurationWindowContent(null)
        setConfigurationWindowContentOriginal(null)
        setResetLoadingMessage(null)
        setWindowContentLoadingMessage(null)
        setWindowContentLoadingError(null)
        setDynamicDeliverables([])
    }

    function resetAdminStatusEditModal() {
        setAdminStatusEditContentModal(null)
    }

    const getEpoch = (dateStr, timeStr) => {
        try {
            if (!timeStr || timeStr.includes('aN')) {
                timeStr = "17:00"
            }
            return new Date(`${dateStr} ${timeStr}`).getTime()
        } catch (err) {
            return null
        }
    }

    const addOrreplace = (mainArr, item) => {
        let found = false
        for (let i = 0; i < mainArr.length; i++) {
            if (mainArr[i][PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] == item[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type]) {
                mainArr[i] = item
                found = true
            }
        }
        if (!found) {
            mainArr.push(item)
        }
        return mainArr
    }

    const getCurrentTime = () => {
        return Date.now();
    }

    function populateDueDateAttributeObject(configurationWindowContent, sub_type, attribute_type, no_wb_attribute_type, no_due_ui_key, date_ui_key, time_ui_key, input){
        let due_date = {}
        due_date['sub_type'] = sub_type
        if (JSON.parse(configurationWindowContent[no_due_ui_key] || "false")) {
            due_date['attribute'] = ''
        } else if(due_date.hasOwnProperty('attribute') && due_date?.['attribute'] == 'NaN'){
            // extra condition is added because the user want to save empty values for the due dates. And the UI component returns NaN. 
            due_date['attribute'] = ''
        }else {
            due_date['attribute'] = getEpoch(configurationWindowContent[date_ui_key], configurationWindowContent[time_ui_key])?.toString()
        }
        due_date['attribute_type'] = attribute_type
        if (due_date['attribute']) {
            input['custom_attributes'] = addOrreplace(input['custom_attributes'], due_date)
        }

        let no_wb_due_date = {}
        no_wb_due_date['sub_type'] = sub_type,
            no_wb_due_date['attribute'] = configurationWindowContent?.[no_due_ui_key]?.toString() || 'false',
            no_wb_due_date['attribute_type'] = no_wb_attribute_type
        if (no_wb_due_date['attribute'] != 'NaN') {
            input['custom_attributes'] = addOrreplace(input['custom_attributes'], no_wb_due_date)
        } 
    }

    const saveControlPanelDetails = () => {

        try{
            setWindowContentLoadingError(null)
            validateMandatoryRestrictions(configurationWindowContent, due_date_keys, ['PRE_TAX_DATE'])
        }catch(e){
            setWindowContentLoadingMessage(null)
            setWindowContentLoadingError(e.message)
            return
        }

        // generate update body
        let input = {}
        input[PROCESS_KEYS.process_id] = configurationWindowContent[PROCESS_KEYS.process_id].toString()
        input[PROCESS_KEYS.process_name] = configurationWindowContent[PROCESS_KEYS.process_name].toString()
        input[PROCESS_KEYS.app_id] = configurationWindowContent[PROCESS_KEYS.app_id] ? configurationWindowContent[PROCESS_KEYS.app_id].toString() : appSettings[currentStage].appId.toString()
        input[PROCESS_KEYS.approvers] = configurationWindowContent[PROCESS_KEYS.approvers]
        input[PROCESS_KEYS.uploaders] = configurationWindowContent[PROCESS_KEYS.uploaders]
        if (!input[PROCESS_KEYS.custom_attributes]) {
            input[PROCESS_KEYS.custom_attributes] = []
        }

        for(let due_date_key in due_date_keys){
            populateDueDateAttributeObject(configurationWindowContent, 'FRISCO', due_date_key, due_date_keys[due_date_key].no_due_attribute_type, due_date_keys[due_date_key].ui_keys.no_wb_due_date, due_date_keys[due_date_key].ui_keys.due_date, due_date_keys[due_date_key].ui_keys.due_time, input)
        }
        // These are for the mandatory files to be uploaded when submit of frisco
        let requiredFields = {}
        requiredFields[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type] = 'FRISCO';
        requiredFields[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] = 'MandatorySupportingDocuments';
        requiredFields[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute] = configurationWindowContent?.mandatoryDocuments?.map(option => option.value).join(',') || '';


        if (requiredFields[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute] !== 'NaN') {
            input[PROCESS_KEYS.custom_attributes] = addOrreplace(input[PROCESS_KEYS.custom_attributes], requiredFields)
        }

        let cadence = {}
        cadence[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type] = 'FRISCO';
        cadence[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] = 'CADENCE';
        cadence[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute] = configurationWindowContent?.cadence || '';
        if (cadence[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute] !== 'NaN') {
            input[PROCESS_KEYS.custom_attributes] = addOrreplace(input[PROCESS_KEYS.custom_attributes], cadence)
        }

        let disabled = {}
        disabled[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type] = 'FRISCO';
        disabled[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] = 'DISABLED';
        disabled[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute] = configurationWindowContent?.disabled || 'false';
        if (disabled[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute] !== 'NaN') {
            input[PROCESS_KEYS.custom_attributes] = addOrreplace(input[PROCESS_KEYS.custom_attributes], disabled)
        }


        // Handle dynamic deliverable aliases
        if (!input.aliases) {
            input.aliases = []
        }

        // Add aliases for all enabled dynamic deliverables
        dynamicDeliverables.forEach(deliverable => {
            const valueKey = `${deliverable.id}_deliverable`;

            // Find the corresponding ID from the dropdown options
            const selectedOption = aliasOptions.find(option => option.label === deliverable.label);
            const aliasType = selectedOption ? selectedOption.value : deliverable.label;

            input.aliases.push({
                alias: configurationWindowContent[valueKey], // Reference value from input field
                alias_type: aliasType, // ID from dropdown (22, 24, 25)
                alias_for: PROCESS_KEYS.process_name
            });
        });

        // Add a default alias for SEC with process_name if there is no alias entered for SEC
        // input.aliases = addDefaultSecAlias(input.aliases, currentStage, input[PROCESS_KEYS.process_name]);


        // Add workstream ID if selected
        if (configurationWindowContent.group_id) {
            input[PROCESS_KEYS.group_id] = configurationWindowContent.group_id.toString()
        }

        input[PROCESS_KEYS.last_updated_by] = userId
        setWindowContentLoadingMessage("Updating, please wait..")
        createAuditLog(`FRISCO#${configurationWindowContent[PROCESS_KEYS.process_id]}`, `${getCurrentTime()}`, "Update via control panel", JSON.stringify(configurationWindowContentOriginal), JSON.stringify(input), "UPDATE REQ", userId)
        updateProcessLite(input, function onSuccess(result) {
            // save the changes if no postwb
            loadAllServicesWithTracksForQuarter(appSettings[currentStage].appId)
            resetModal()
        }, function onFailure(result) {
            resetModal()
        })
    }

    const resolveDueDatesForView = (due_date_key, i, item) => {
        var due_date = new Date(parseInt(item[PROCESS_KEYS.custom_attributes][i][PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute]))
                let month = ("0" + (due_date.getMonth() + 1)).slice(-2)
                let date = ("0" + due_date.getDate()).slice(-2)
                let hours = ("0" + due_date.getHours()).slice(-2)
                let mins = ("0" + due_date.getMinutes()).slice(-2)
                item[due_date_keys[due_date_key].ui_keys.due_date] = `${due_date.getFullYear()}-${month}-${date}`
                item[due_date_keys[due_date_key].ui_keys.due_time] = `${hours}:${mins}`
    }

    const getDueDates = (item) => {
        for (let i = 0; i < item?.[PROCESS_KEYS.custom_attributes]?.length; i++) {
            let attribute_type = item[PROCESS_KEYS.custom_attributes][i][PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type]
            if (due_date_keys.hasOwnProperty(attribute_type)) {
                resolveDueDatesForView(attribute_type, i, item)
            }

            if (item[PROCESS_KEYS.custom_attributes][i][PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] == 'NO_PRE_WB_DUE_DATE') {
                item['no_pre_wb_due_date'] = JSON.parse(item[PROCESS_KEYS.custom_attributes][i][PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute])
            }
            if (item[PROCESS_KEYS.custom_attributes][i][PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] == 'NO_POST_WB_DUE_DATE') {
                item['no_post_wb_due_date'] = JSON.parse(item[PROCESS_KEYS.custom_attributes][i][PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute])
            }

            if (item[PROCESS_KEYS.custom_attributes][i][PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] == 'NO_PRE_TAX_DATE') {
                item['no_pre_tax_date'] = JSON.parse(item[PROCESS_KEYS.custom_attributes][i][PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute])
            }
            if (item[PROCESS_KEYS.custom_attributes][i][PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] == 'NO_POST_TAX_DATE') {
                item['no_post_tax_date'] = JSON.parse(item[PROCESS_KEYS.custom_attributes][i][PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute])
            }

            if (item[PROCESS_KEYS.custom_attributes][i][PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] == 'CADENCE') {
                item['cadence'] = item[PROCESS_KEYS.custom_attributes][i][PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute]
            }
            if (item[PROCESS_KEYS.custom_attributes][i][PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] == 'DISABLED') {
                item['disabled'] = item[PROCESS_KEYS.custom_attributes][i][PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute]
            }
        }
        return item
    }

    const setConfigWindowJson = (item) => {
        var copyItem = JSON.parse(JSON.stringify(item));
        copyItem = getDueDates(copyItem)

        // COnvert back from comma seperated required documents to Select useable struct
        if (copyItem.custom_attributes) {
            const mandatoryDocsAttribute = copyItem.custom_attributes.find(
                attr => attr.attribute_type === 'MandatorySupportingDocuments'
            );
            if (mandatoryDocsAttribute?.attribute) {
                // Split comma-separated string and reconstruct array of objects
                copyItem.mandatoryDocuments = mandatoryDocsAttribute.attribute.split(',')
                    .filter(value => value)
                    .map(value => ({
                        label: value,
                        value: value
                    }));
            } else {
                copyItem.mandatoryDocuments = [];
            }
        }

        // Load alias data from service_aliases table and update dynamic deliverables
        const updatedDynamicDeliverables = [...dynamicDeliverables];

        if (copyItem?.service_aliases && Array.isArray(copyItem.service_aliases)) {
            copyItem.service_aliases.forEach(alias => {
                // Check if we already have a deliverable with this alias_type
                const existingDeliverable = updatedDynamicDeliverables.find(d => d?.alias_type === alias?.alias_type);
                if (existingDeliverable) {
                    // Update existing deliverable with the alias data
                    copyItem[`${existingDeliverable.id}_deliverable`] = alias?.alias;
                    copyItem[`${existingDeliverable.id}_deliverable_enabled`] = true;
                } else {
                    // Create new deliverable only if one with this alias_type doesn't exist
                    const newId = `deliverable_${alias?.alias_type.toLowerCase()}_${Math.random().toString(36).substr(2, 9)}`;
                    // Map the stored ID back to the corresponding label
                    const aliasOption = aliasOptions.find(option => option.value === alias?.alias_type);
                    const labelText = aliasOption ? aliasOption.label : alias?.alias_type;

                    const newDeliverable = {
                        id: newId,
                        label: labelText,
                        placeholder: 'REF1.1',
                        alias_type: alias?.alias_type
                    };
                    updatedDynamicDeliverables.push(newDeliverable);
                    copyItem[`${newId}_deliverable`] = alias?.alias;
                    copyItem[`${newId}_deliverable_enabled`] = true;
                }
            });
        }

        // Update the dynamic deliverables state
        setDynamicDeliverables(updatedDynamicDeliverables);
        setConfigurationWindowContent(copyItem)
        var copyItem = JSON.parse(JSON.stringify(item));
        setConfigurationWindowContentOriginal(copyItem)
    }

    const savePreference = async () => {
        if (gridRef.current) {
            const gridApi = gridRef.current.api;
            if (gridViewPreference?.preferenceId) {
                setPreferenceButtonLoaderMessage("Saving view..")
                createAuditLog(`CUSTOM_DASHBOARD#${appSettings[currentStage].appId}`, `PREFERENCE#${Date.now()}`, "Dashboard preference altered", JSON.stringify(gridApi.getColumnState()), null, "DASHBOARD PREFERENCE ALTERED", userId)
                updatePreference(gridViewPreference.preferenceId, 'PREFERENCE', userId, gridApi.getColumnState() || {}, function onSuccess(response) {
                    setPreferenceButtonLoaderMessage(null)
                    setHasViewChanged(false)
                })
            } else {
                let preferenceId = uuidv4()
                setPreferenceButtonLoaderMessage("Saving view..")
                createAuditLog(`CUSTOM_DASHBOARD#${appSettings[currentStage].appId}`, `PREFERENCE#${Date.now()}`, "Dashboard preference created", JSON.stringify(gridApi.getColumnState()), null, "DASHBOARD PREFERENCE CREATED", userId)
                createPreference(preferenceId, 'CUSTOM_DASHBOARD_PREFERENCE', 'PREFERENCE', appSettings[currentStage].appId, 'APP', userId, gridApi.getColumnState() || {}, null, function onSuccess(response) {
                    setPreferenceButtonLoaderMessage(null)
                    setHasViewChanged(false)
                })
            }
        }
    }

    const resetView = () => {
        gridRef?.current?.api?.resetColumnState()
        setHasViewChanged(true);
    }

    const getPstDate = (date, time) => {
        if (!date || date.includes('aN')) return null;
        const utcString = `${date}T${time || '00:00'}`;
        const options = {
            timeZone: 'America/Los_Angeles',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
            timeZoneName: 'short'
        };
        return new Date(utcString);
    };

    const findDeliverableMatch = (allDeliverables, referenceValue, titleValue) => {
        const cleanedTitle = titleValue.replace(/["*\\/:<?|]/g, '');
        return allDeliverables.find(spec => {
            let matchesName;
            let matchesAlias;
            let matchesFullName;
            if(spec?.flex_id){
                matchesName = spec.template_name === referenceValue;
                matchesFullName = spec.label === cleanedTitle;
                matchesAlias = spec.service_aliases?.some(alias => alias.alias === referenceValue);
            }else{
                matchesName = spec.process_name === referenceValue;
                matchesFullName = spec.label === cleanedTitle;
                matchesAlias = spec.service_aliases?.some(alias => alias.alias === referenceValue);
            }
            // Now matching against reference and fullname always
            return (matchesName || matchesAlias) && matchesFullName;
        });
    };

    const parseExcelDate = (dateStr) => {
        if (!dateStr || !dateStr.toString().trim()) return null;
        const trimmed = dateStr.toString().trim().toLowerCase();
        
        // Handle special cases for today's date
        if (trimmed === 'eod' || trimmed === 'noon') {
            const today = new Date();
            const month = (today.getMonth() + 1).toString().padStart(2, '0');
            const day = today.getDate().toString().padStart(2, '0');
            const year = today.getFullYear();
            const time = trimmed === 'noon' ? '12:00' : '17:00';
            return `${year}-${month}-${day} ${time}`;
        }
        
        // Check if it's already in ISO format or standard date format
        if (trimmed.includes('T') || trimmed.includes('-')) {
            return trimmed;
        }
        
        // Only process if it contains '/' (MM/DD/YY format)
        if (!trimmed.includes('/')) {
            return null; // Invalid pattern
        }
        
        const parts = trimmed.split(/\s+/);
        if (parts.length < 2) return null; // Invalid pattern
        
        const datePart = parts[0];
        const timePart = parts[1];
        
        const dateComponents = datePart.split('/');
        if (dateComponents.length !== 3) return null; // Invalid pattern
        
        const [month, day, year] = dateComponents;
        if (!month || !day || !year) return null; // Invalid pattern
        
        const fullYear = year.length === 2 ? `20${year}` : year;
        
        let time = '12:00';
        if (timePart === 'noon') time = '12:00';
        else if (timePart === 'eod') time = '17:00';
        else if (timePart.includes('am') || timePart.includes('pm')) {
            const hourStr = timePart.replace(/[ap]m/i, '');
            const hour = parseInt(hourStr);
            if (isNaN(hour)) return null; // Invalid pattern
            const isPM = timePart.toLowerCase().includes('pm');
            let hour24;
            if (isPM) {
                hour24 = hour === 12 ? 12 : hour + 12;
            } else {
                hour24 = hour === 12 ? 0 : hour;
            }
            time = `${hour24.toString().padStart(2, '0')}:00`;
        } else {
            return null; // Invalid time pattern
        }
        
        return `${fullYear}-${month.padStart(2, '0')}-${day.padStart(2, '0')} ${time}`;
    };

    const handleFileUpload = (file) => {
        setFileError('');
        const allDeliverables = [...deliverables];
        if (file) {
            setFileName(file.name);
            const reader = new FileReader();
            reader.onload = (e) => {
                const isExcel = file.name.endsWith('.xlsx') || file.name.endsWith('.xls');
                let rows = [];
                
                if (isExcel) {
                    try {
                        const data = new Uint8Array(e.target.result);
                        const workbook = XLSX.read(data, { type: 'array' });
                        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                        rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                    } catch (error) {
                        setFileError('Error reading Excel file. Please check the file format.');
                        return;
                    }
                } else {
                    const text = e.target.result;
                    rows = text.trim().split('\n').map(line => line.split(','));
                }
                
                if (rows.length < 2 || rows[0].length !== BULK_UPLOAD_EXPECTED_HEADERS.length || 
                    !BULK_UPLOAD_EXPECTED_HEADERS.every((header, index) => rows[0][index] === header)) {
                    setFileError('Invalid data in File. Please Follow the standard template provided.');
                    return;
                }
                
                let errorsount = 0;
                const parsedData = rows.slice(1).map(row => {
                    const [deliverableRef, originalTitle, preDueDate, postDueDate, postTaxDate] = row;
                    //Remove forbidden characters: " * / : < > ? |
                    const title = originalTitle.replace(/["*\/:<?|]/g, '');
                    const isDeliverableAvail = findDeliverableMatch(allDeliverables, deliverableRef, originalTitle);
                    
                    const parsedPreDueDate = parseExcelDate(preDueDate);
                    const parsedPostDueDate = parseExcelDate(postDueDate);
                    const parsedPostTaxDueDate = parseExcelDate(postTaxDate);
                    
                    let status = '';
                    status += isDeliverableAvail ? '' : 'No Deliverable Matched with Given Reference or Title. ';
                    if (preDueDate && parsedPreDueDate === null) status += 'Invalid Pre Due Date format. ';
                    if (postDueDate && parsedPostDueDate === null) status += 'Invalid Post Due Date format. ';
                    if (postTaxDate && parsedPostTaxDueDate === null) status += 'Invalid Post Tax Date format. ';
                    if (cadence && !['Quarterly', 'Annual', 'Both'].includes(cadence)) status += 'Invalid Cadence value. Must be Quarterly, Annual, or Both. ';
                    if (disabled && !['Yes', 'No'].includes(disabled)) status += 'Invalid Disabled value. Must be Yes or No. ';
                    if (mandatoryDocs && mandatoryDocs.trim()) {
                        const allowedTypes = ['pdf', 'excel', 'word', 'csv'];
                        const docTypes = mandatoryDocs.split(',').map(doc => doc.trim().toLowerCase());
                        const invalidTypes = docTypes.filter(type => !allowedTypes.includes(type));
                        if (invalidTypes.length > 0) {
                            status += `Invalid Mandatory Documents: ${invalidTypes.join(', ')}. Only pdf, excel, word, csv are allowed. `;
                        }
                    }
                    
                    if (status) {
                        errorsount++;
                    }
                    return { 
                        name: deliverableRef || title, 
                        title: title,
                        cadence: cadence,
                        disabled: disabled,
                        preDueDate: parsedPreDueDate, 
                        postDueDate: parsedPostDueDate, 
                        postTaxDate: parsedPostTaxDueDate,
                        mandatoryDocs: mandatoryDocs,
                        uploadersAlias: uploadersAlias,
                        uploadersLDAP: uploadersLDAP,
                        reviewers: reviewers,
                        reviewersLDAP: reviewersLDAP,
                        approvers: approvers,
                        approversLDAP: approversLDAP,
                        noPreDueDate: preDueDate?.toString().trim() ? 'no' : 'yes',
                        noPostDueDate: postDueDate?.toString().trim() ? 'no' : 'yes',
                        noPreTax: 'yes',
                        noPostTax: postTaxDate?.toString().trim() ? 'no' : 'yes',
                        preTaxDate: null,
                        status 
                    };
                });
                setCsvData(parsedData);
                setBulkErrorsCount(errorsount);
                setIsUploadBtnEnabled(errorsount === 0);
            };
            
            if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
                reader.readAsArrayBuffer(file);
            } else {
                reader.readAsText(file);
            }
        }
    };

    const handleSaveUploadData = () => {
        setIsUploadBtnEnabled(false);
        const allDeliverables = [...deliverables];
        const inputData = [...csvData];
        for (let i = 0; i < inputData.length; i++) {
            const item = inputData[i];

            if (item.status != '') {
                continue;
            }

            inputData[i].status = 'Updating...';
            setCsvData([...inputData]);

            const deliverableData = findDeliverableMatch(allDeliverables, item.name, item.name);

            if (deliverableData.flex_id) {
                let input = {}
                input['flex_id'] = deliverableData['flex_id'].toString()
                input['template_name'] = deliverableData['template_name']
                input[PROCESS_KEYS.app_id] = deliverableData[PROCESS_KEYS.app_id] ? deliverableData[PROCESS_KEYS.app_id].toString() : appSettings[currentStage].appId.toString()
                input[PROCESS_KEYS.approvers] = deliverableData[PROCESS_KEYS.approvers]
                input[PROCESS_KEYS.uploaders] = deliverableData[PROCESS_KEYS.uploaders]
                input['parameters'] = deliverableData['parameters']
                input['label'] = deliverableData['label']
                input['status'] = deliverableData['status']
                input['mapping_id'] = deliverableData['mapping_id'].toString()
                input['approval_days'] = deliverableData['approval_days']
                input['approval_required'] = deliverableData['approval_required']
                input['description'] = deliverableData['description']
                input['file_types'] = deliverableData['file_types']
                input['group_id'] = deliverableData['group_id']
                input['next_step'] = deliverableData['next_step']
                input['step_function_name'] = deliverableData['step_function_name']
                if (!input[PROCESS_KEYS.custom_attributes]) {
                    input[PROCESS_KEYS.custom_attributes] = []
                }

                // Process cadence
                if (item.cadence) {
                    let cadence = {}
                    cadence[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type] = 'FLEXICO'
                    cadence[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] = 'CADENCE'
                    const cadenceMap = { 'Quarterly': 'QUARTERLY', 'Annual': 'ANNUALLY', 'Both': 'BOTH' }
                    cadence[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute] = cadenceMap[item.cadence] || item.cadence
                    input[PROCESS_KEYS.custom_attributes] = addOrreplace(input[PROCESS_KEYS.custom_attributes], cadence)
                }

                // Process disabled flag
                if (item.disabled) {
                    let disabled = {}
                    disabled[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type] = 'FLEXICO'
                    disabled[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] = 'DISABLED'
                    disabled[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute] = item.disabled === 'Yes' ? 'true' : 'false'
                    input[PROCESS_KEYS.custom_attributes] = addOrreplace(input[PROCESS_KEYS.custom_attributes], disabled)
                }

                // Process mandatory documents
                if (item.mandatoryDocs) {
                    let mandatoryFields = {}
                    mandatoryFields[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type] = 'FLEXICO'
                    mandatoryFields[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] = 'MandatorySupportingDocuments'
                    mandatoryFields[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute] = item.mandatoryDocs
                    input[PROCESS_KEYS.custom_attributes] = addOrreplace(input[PROCESS_KEYS.custom_attributes], mandatoryFields)
                }

                // Process uploaders and approvers
                if (item.uploadersAlias || item.uploadersLDAP) {
                    let uploaders = []
                    if (item.uploadersAlias) {
                        item.uploadersAlias.split(',').forEach(alias => {
                            uploaders.push({ alias: alias.trim(), type: 'UPLOADER' })
                        })
                    }
                    if (item.uploadersLDAP) {
                        item.uploadersLDAP.split(',').forEach(alias => {
                            uploaders.push({ alias: alias.trim(), type: 'UPLOADER_LDAP' })
                        })
                    }
                    input[PROCESS_KEYS.uploaders] = uploaders
                }

                if (item.reviewers || item.reviewersLDAP || item.approvers || item.approversLDAP) {
                    let approvers = []
                    if (item.reviewers) {
                        item.reviewers.split(',').forEach(alias => {
                            approvers.push({ alias: alias.trim(), type: 'APPROVER', column_index: 0 })
                        })
                    }
                    if (item.reviewersLDAP) {
                        item.reviewersLDAP.split(',').forEach(alias => {
                            approvers.push({ alias: alias.trim(), type: 'APPROVER_LDAP', column_index: 0 })
                        })
                    }
                    if (item.approvers) {
                        item.approvers.split(',').forEach(alias => {
                            approvers.push({ alias: alias.trim(), type: 'APPROVER', column_index: 1 })
                        })
                    }
                    if (item.approversLDAP) {
                        item.approversLDAP.split(',').forEach(alias => {
                            approvers.push({ alias: alias.trim(), type: 'APPROVER_LDAP', column_index: 1 })
                        })
                    }
                    input[PROCESS_KEYS.approvers] = approvers
                }

                for(let due_date_key in due_date_keys){
                    let due_date = {}
                    due_date[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type] = 'FLEXICO'
                    due_date[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute] = (item?.[due_date_keys[due_date_key].ui_keys.due_date_flexico] ? (new Date(item[due_date_keys[due_date_key].ui_keys.due_date_flexico]).getTime())?.toString() : '')
                    due_date[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] = due_date_key
                    input[PROCESS_KEYS.custom_attributes] = addOrreplace(input[PROCESS_KEYS.custom_attributes], due_date)

                    let no_wb_due_date = {} 
                    no_wb_due_date[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type] = 'FLEXICO',
                    no_wb_due_date[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute] = item?.[due_date_keys[due_date_key].ui_keys.no_wb_due_date_v2]?.toLowerCase() === 'yes' ? 'true' : 'false'
                    no_wb_due_date[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] = due_date_keys[due_date_key].no_due_attribute_type
                    input[PROCESS_KEYS.custom_attributes] = addOrreplace(input[PROCESS_KEYS.custom_attributes], no_wb_due_date)
                }
                input[PROCESS_KEYS.last_updated_by] = userId

                updateFlexicoTemplate(
                    input,
                    function onSuccess(response) {
                        inputData[i].status = 'Success';
                        setCsvData([...inputData]);
                        loadAllServicesWithTracksForQuarter(appSettings[currentStage].appId)
                    },
                    function onFailure(error) {
                        inputData[i].status = 'Failed';
                        setCsvData([...inputData])
                    }
                );


            } else {
                let input = {};
                input[PROCESS_KEYS.process_id] = deliverableData.process_id.toString()
                input[PROCESS_KEYS.process_name] = item.name

                input[PROCESS_KEYS.custom_attributes] = []

                // Process cadence
                if (item.cadence) {
                    let cadence = {}
                    cadence[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type] = 'FRISCO'
                    cadence[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] = 'CADENCE'
                    const cadenceMap = { 'Quarterly': 'QUARTERLY', 'Annual': 'ANNUALLY', 'Both': 'BOTH' }
                    cadence[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute] = cadenceMap[item.cadence] || item.cadence
                    input[PROCESS_KEYS.custom_attributes] = addOrreplace(input[PROCESS_KEYS.custom_attributes], cadence)
                }

                // Process disabled flag
                if (item.disabled) {
                    let disabled = {}
                    disabled[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type] = 'FRISCO'
                    disabled[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] = 'DISABLED'
                    disabled[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute] = item.disabled === 'Yes' ? 'true' : 'false'
                    input[PROCESS_KEYS.custom_attributes] = addOrreplace(input[PROCESS_KEYS.custom_attributes], disabled)
                }

                // Process mandatory documents
                if (item.mandatoryDocs) {
                    let mandatoryFields = {}
                    mandatoryFields[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type] = 'FRISCO'
                    mandatoryFields[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] = 'MandatorySupportingDocuments'
                    mandatoryFields[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute] = item.mandatoryDocs
                    input[PROCESS_KEYS.custom_attributes] = addOrreplace(input[PROCESS_KEYS.custom_attributes], mandatoryFields)
                }

                for (let due_date_key in due_date_keys) {
                    let due_date = {}
                    due_date[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type] = 'FRISCO',
                    due_date[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute] = (item?.[due_date_keys[due_date_key].ui_keys.due_date_flexico] ? (new Date(item[due_date_keys[due_date_key].ui_keys.due_date_flexico]).getTime())?.toString() : ''),
                    due_date[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] = due_date_key
                    input[PROCESS_KEYS.custom_attributes] = addOrreplace(input[PROCESS_KEYS.custom_attributes], due_date)

                    let no_wb_due_date = {}
                    no_wb_due_date[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type] = 'FRISCO',
                    no_wb_due_date[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute] = item?.[due_date_keys[due_date_key].ui_keys.no_wb_due_date_v2]?.toLowerCase() === 'yes' ? 'true' : 'false',
                    no_wb_due_date[PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type] = due_date_keys[due_date_key].no_due_attribute_type
                    input[PROCESS_KEYS.custom_attributes] = addOrreplace(input[PROCESS_KEYS.custom_attributes], no_wb_due_date)
                }
                input[PROCESS_KEYS.app_id] = deliverableData[PROCESS_KEYS.app_id] ? deliverableData[PROCESS_KEYS.app_id].toString() : appSettings[currentStage].appId.toString()
                
                // Process uploaders and approvers
                if (item.uploadersAlias || item.uploadersLDAP) {
                    let uploaders = []
                    if (item.uploadersAlias) {
                        item.uploadersAlias.split(',').forEach(alias => {
                            uploaders.push({ alias: alias.trim(), type: 'UPLOADER' })
                        })
                    }
                    if (item.uploadersLDAP) {
                        item.uploadersLDAP.split(',').forEach(alias => {
                            uploaders.push({ alias: alias.trim(), type: 'UPLOADER_LDAP' })
                        })
                    }
                    input[PROCESS_KEYS.uploaders] = uploaders
                } 

                if (item.reviewers || item.reviewersLDAP || item.approvers || item.approversLDAP) {
                    let approvers = []
                    if (item.reviewers) {
                        item.reviewers.split(',').forEach(alias => {
                            approvers.push({ alias: alias.trim(), type: 'APPROVER', column_index: 0 })
                        })
                    }
                    if (item.reviewersLDAP) {
                        item.reviewersLDAP.split(',').forEach(alias => {
                            approvers.push({ alias: alias.trim(), type: 'APPROVER_LDAP', column_index: 0 })
                        })
                    }
                    if (item.approvers) {
                        item.approvers.split(',').forEach(alias => {
                            approvers.push({ alias: alias.trim(), type: 'APPROVER', column_index: 1 })
                        })
                    }
                    if (item.approversLDAP) {
                        item.approversLDAP.split(',').forEach(alias => {
                            approvers.push({ alias: alias.trim(), type: 'APPROVER_LDAP', column_index: 1 })
                        })
                    }
                    input[PROCESS_KEYS.approvers] = approvers
                } 
                input[PROCESS_KEYS.last_updated_by] = userId

                updateProcessLite(input, function onSuccess(result) {
                    inputData[i].status = 'Success';
                    setCsvData([...inputData]);
                    loadAllServicesWithTracksForQuarter(appSettings[currentStage].appId)
                }, function onFailure(result) {
                    inputData[i].status = 'Failed';
                    setCsvData([...inputData])
                })
            }
        }
    }

    function onFilterTextBoxChanged() {
        gridRef?.current?.api?.setGridOption(
            "quickFilterText",
            quickFilterText,
        );
    }

    async function getFilterModel(quickFilterId) {
        let ldaps = await getCachedLdaps(currentStage)
        ldaps = JSON.parse(ldaps)
        if (quickFilterId == 'all') {
            return null
        } else if (quickFilterId == 'preparer') {
            return {
                "uploaders": {
                    values: [userId, ...ldaps]
                },
            }
        } else if (quickFilterId == 'reviewer') {
            return {
                "reviewers": {
                    values: [userId, ...ldaps]
                },
            }
        } else if (quickFilterId == 'l8reviewer') {
            return {
                "l8reviewers": {
                    values: [userId, ...ldaps]
                },
            }
        } else if (quickFilterId == 'completed') {
            return {
                "prewbstatus": {
                    values: ['COMPLETED']
                },
                "postwbstatus": {
                    values: ['COMPLETED']
                }
            }
        } else if (quickFilterId == 'incomplete') {
            return null
        }
    }

    async function quickFilter(quickFilterId) {
        let ldaps = await getCachedLdaps(currentStage)
        ldaps = JSON.parse(ldaps)
        gridRef?.current?.api?.setFilterModel(await getFilterModel(quickFilterId))
        gridRef?.current?.api?.onFilterChanged()
    }

    async function getQuickFilterCounts(quickFilterId) {
        const existingFilterModel = gridRef?.current?.api?.getFilterModel();
        gridRef?.current?.api?.setFilterModel(await getFilterModel(quickFilterId));
        const filteredCount = gridRef?.current?.api?.getDisplayedRowCount();
        gridRef?.current?.api?.setFilterModel(existingFilterModel);
        return filteredCount
    }

    function editStatusInIntervalTracking(wb_type, data) {
        let type = null
        if (data.hasOwnProperty('process_id')) {
            type = 'FRISCO'
        } else if (data.hasOwnProperty('flex_id')) {
            type = 'FLEXICO'
        }
        setAdminStatusEditContentModal({ 'wb_type': wb_type, 'type': type, 'data': data, 'status': getStatusForMultipleStatus(data, getWBStatusBasedOnCustomAttributes(data, wb_type)) })
    }

    const resetGridView = () => {
        if (gridRef.current) {
            const gridApi = gridRef.current.api;
            const columnApi = gridRef.current.columnApi;

            // Clear Filters
            gridApi?.setFilterModel(null);

            // Clear Sorting
            columnApi?.applyColumnState({
                defaultState: { sort: null },
            });

            // Reset Columns
            columnApi?.resetColumnState();

            // Reset Pinned Columns
            columnApi?.setPivotMode(false);

            // // Resize to fit
            // gridApi?.sizeColumnsToFit();

            // Redraw the grid
            gridApi?.redrawRows();
        }
    };

    const isExternalFilterPresent = useCallback(() => {
        // hide annual filter for non admins for rest of the year except Q1 - when the preparers upload Q4 data
        return (!isAdmin.current && getCurrentQuarter()!="Q1") || quickFilterId === 'incomplete';
    }, [quickFilterId]);

    const doesExternalFilterPass = useCallback(
        (params) => {
            const passesAnnualFilter = isAdmin.current || getCurrentQuarter()=="Q1" || !isAnnualOnlyDeliverable(getCadenceAttribute(params.data?.custom_attributes));
            if (quickFilterId === 'incomplete') {
                const preStatus = getStatus(params.data, getOneWBStatusBasedOnCustomAttributes(params.data, 'PreWB'))?.overall_status;
                const postStatus = getStatusForMultipleStatus(params.data, getWBStatusBasedOnCustomAttributes(params.data, 'PostWB'))?.overall_status;
                const isIncomplete = preStatus === 'INCOMPLETE' || postStatus === 'INCOMPLETE';
                return passesAnnualFilter && isIncomplete;
            }
            return passesAnnualFilter;
        },
        [isAdmin.current, quickFilterId],
    );


    const checkUserUploaderAccess = async (uploaders) => {
        if (!uploaders || uploaders.length === 0) return false;
        
        // Check if user is directly in uploaders list
        const directUploader = uploaders.find(uploader => 
            uploader.type === 'UPLOADER' && uploader.alias === userId
        );
        if (directUploader) return true;
        
        // Check if user is member of any uploader LDAP groups
        const ldapUploaders = uploaders.filter(uploader => uploader.type === 'UPLOADER_LDAP');
        for (const ldapUploader of ldapUploaders) {
            const isMember = await isMemberOf(userId, ldapUploader.alias, currentStage);
            if (isMember) return true;
        }
        
        return false;
    };

    const getRowId = useCallback(
    (params) => {
        return getDeliverableMapperKey(params.data)
    },
    [],
  );

    const handleGridViewChanges = (event) => {
        // Only track manual changes
        if (event.source === 'uiColumnMoved' ||
            event.source === 'uiColumnResized' ||
            event.source === 'uiColumnDragged' ||
            event.source === 'columnMenu' ||
            event.source === 'toolPanelUi') {
            setHasViewChanged(true);
        }
    };

    const setSavedPreference = () => {
        listPreference(appSettings[currentStage].appId, 'APP', 'CUSTOM_DASHBOARD_PREFERENCE', function onSuccess(response) {
            let item = response?.data?.listPreference?.['items']?.[0] || {}
            setGridViewPreference(item)
            if (item.hasOwnProperty('information')) {
                item['information'] = JSON.parse(item?.['information'])
            }
            const gridApi = gridRef?.current?.api;
            gridApi?.applyColumnState({
                state: item.information,
                applyOrder: true,
                defaultState: {
                    flex: null  
                }
            });
        }, function onFailure(response) {
        })
    }

    const onGridReady = useCallback((params) => {
        setSavedPreference()
    }, []);

    const onRowGroupOpened = (event) => {
        setExpandedState(prev => ({
            ...prev,
            [event.node.id]: event.expanded
        }));
    };

    const getDisplayName = (params, aliasOption, index) => {
        // Find the alias value for this specific alias type
        const aliasSource = params.data?.process_id ? params.data?.service_aliases : params.data?.aliases;
        const aliasValue = aliasSource?.find(alias => alias.alias_type === aliasOption?.value)?.alias;

        // Check if all 3 alias columns have '-' values
        const allAliasesEmpty = aliasOptions.every(option =>
            !aliasSource?.find(alias => alias.alias_type === option.value)?.alias
        );

        // If all aliases are empty and this is the first column, show process/template name
        const displayValue = (allAliasesEmpty && index === 0)
            ? (params.data.flex_id ? params.data[FLEXICO_TEMPLATE_KEYS.template_name] : params.data[PROCESS_KEYS.process_name])
            : (aliasValue || '-');
        return displayValue
    };

    const getCadenceAttribute = (customAttributes) => {
        return customAttributes?.find(attr => attr.attribute_type === "CADENCE")?.attribute || null;
    };

    const Content = (
        currentStage ?
            <ContentLayout defaultPadding={true}>
                <Modal
                    onDismiss={() => {
                        setShowUploadDeliverablesDueDateModal(false);
                        setCsvData([]);
                        setFileName('');
                        setFileError('');
                        setBulkErrorsCount(0);
                    }}
                    size='max'
                    visible={showUploadDeliverablesDueDateModal}
                    header={
                        <div>
                            <span style={{ marginRight: "12px" }}>Upload Deliverables Information</span>
                            <Link external href={TEMPLATE_DOWNLOAD_URL} variant="info">Download Template</Link>
                        </div>
                    }
                    footer={
                        <Box float="right"> <SpaceBetween direction='horizontal' size='s'>
                            <Button onClick={() => {
                                setShowUploadDeliverablesDueDateModal(false);
                                setCsvData([]);
                                setFileName('');
                                setFileError('');
                                setBulkErrorsCount(0);
                            }}>Cancel</Button>
                            <Button variant='primary' onClick={handleSaveUploadData} disabled={!isUploadBtnEnabled}>Upload</Button>
                        </SpaceBetween> </Box>
                    }
                >

                    <SpaceBetween size='m'>

                        <FileInput
                            accept=".csv,.xlsx,.xls"
                            value={uploadedFiles}
                            onChange={({ detail }) => {
                                setUploadedFiles(detail.value);
                                handleFileUpload(detail?.value?.[0])
                            }}
                        >Choose File</FileInput>

                        {fileName && (
                            <Box><strong>Selected File:</strong> {fileName}</Box>
                        )}

                        {fileError && <Alert type="error">{fileError}</Alert>}

                        {!(bulkErrorsCount === 0) && <Alert type="error">You have {bulkErrorsCount} errors. Please check status column.</Alert>}

                        {csvData.length > 0 && (
                            <Table
                                columnDefinitions={[
                                    {
                                        header: 'Status', cell: item => {
                                            if (item.status === 'Success') {
                                                return <StatusIndicator>Success</StatusIndicator>
                                            } else if (item.status === 'Failed') {
                                                return <StatusIndicator type="error">Failed</StatusIndicator>
                                            } else if (item.status === 'Updating...') {
                                                return (<Spinner />)
                                            } else if (item.status === '') {
                                                return;
                                            } else {
                                                return <div style={{ width: "200px", whiteSpace: "normal", wordBreak: "normal" }}><StatusIndicator type="error">{item.status}</StatusIndicator></div>
                                            }
                                        }, maxWidth: 200, wrap: true
                                    },
                                    { header: 'Deliverable Reference', cell: item => item.name },
                                    { header: 'Title', cell: item => item.title || '-' },
                                    { header: 'Cadence', cell: item => item.cadence || '-' },
                                    { header: 'Disable This Deliverable', cell: item => item.disabled || '-' },
                                    { header: 'Pre-WB Due Date and Time', cell: item => item.preDueDate },
                                    { header: 'Post-WB Due Date and Time', cell: item => item.postDueDate },
                                    { header: 'Pre-WB Post-Tax Due Date and Time (10-K only)', cell: item => item.postTaxDate },
                                    { header: 'Mandatory Documents', cell: item => item.mandatoryDocs || '-' },
                                    { header: 'Uploaders Alias', cell: item => item.uploadersAlias || '-' },
                                    { header: 'Uploaders LDAP', cell: item => item.uploadersLDAP || '-' },
                                    { header: 'Reviewers', cell: item => item.reviewers || '-' },
                                    { header: 'Reviewers LDAP', cell: item => item.reviewersLDAP || '-' },
                                    { header: 'Approvers', cell: item => item.approvers || '-' },
                                    { header: 'Approvers LDAP', cell: item => item.approversLDAP || '-' },
                                ]}
                                items={csvData}
                                variant='embedded'
                                stickyHeader={false}
                            />
                        )}
                    </SpaceBetween>

                </Modal>

                
                <SpaceBetween direction='vertical' size='m'>
                    <Grid
                        gridDefinition={[{ colspan: 2 }, { colspan: 2 }, { colspan: 2 }, { colspan: 2 }, { colspan: 2 }]}
                    >
                        <Box textAlign='center'><img className='craLogo' src={craLogo}></img></Box>
                        <Container>
                            <Grid gridDefinition={[{ colspan: 8 }, { colspan: 4 }]}>
                                <h3 class='deliverables_count_text'>All Deliverables</h3>
                                <h3 class='deliverables_count_number blue_text'>{allDeliverablesCount}</h3>
                            </Grid>
                        </Container>
                        <Container>
                            <Grid gridDefinition={[{ colspan: 8 }, { colspan: 4 }]}>
                                <h3 class='deliverables_count_text'>Not Due</h3>
                                <h3 class='deliverables_count_number blue_text'>{notDueCount}</h3>
                            </Grid>
                        </Container>
                        <Container>
                            <Grid gridDefinition={[{ colspan: 8 }, { colspan: 4 }]}>
                                <h3 class='deliverables_count_text'>Due Today</h3>
                                <h3 class='deliverables_count_number blue_text'>{dueTodayCount}</h3>
                            </Grid>
                        </Container>
                        <Container>
                            <Grid gridDefinition={[{ colspan: 8 }, { colspan: 4 }]}>
                                <h3 class='deliverables_count_text red_text'>Overdue</h3>
                                <h3 class='deliverables_count_number blue_text'>{overdueCount}</h3>
                            </Grid>
                        </Container>
                        {/* <Container>
                            <Grid gridDefinition={[{ colspan: 8 }, { colspan: 4 }]}>
                                <h3 class='deliverables_count_text'>Pending Approvals</h3>
                                <h3 class='deliverables_count_number blue_text'>{pendingApprovalCount}</h3>
                            </Grid>
                        </Container> */}
                    </Grid>                        


                    <Box padding={{top:'m'}}>
<SpaceBetween direction='vertical' size='xl'>
        <Alert type='info'>
                            {LEAD_SHEET_NOTICE}{' '}
                            <a href={LEAD_SHEET_TEMPLATES_URL} target="_blank" rel="noopener noreferrer">Download current templates</a>.
                            <br />
                            {NEW_TO_CORP_REPORTING}{' '}
                            <a href={CORP_REPORTING_GUIDE_URL} target="_blank" rel="noopener noreferrer">Wiki Instructions</a>
                        </Alert>
                        {isDeliverablesLocked && (
                            <Alert type='warning'>
                                All Deliverables have been locked, if you believe this to be wrong, please contact the SEC Team
                            </Alert>
                        )}
                            <Grid
                                gridDefinition={[{ colspan: 6 }, { colspan: 4 }, {colspan:2}]}
                            >
                                <Input
                                    onChange={({ detail }) => setQuickFilterText(detail.value)}
                                    value={quickFilterText}
                                    expandToViewport={true}
                                    placeholder='Type to search'
                                />
                                <SpaceBetween direction='horizontal' size='xl'>
                                    <Button iconName="close" onClick={() => {
                                        setQuickFilterText('')
                                    }} > Clear</Button>
                                    <Button iconName="refresh" onClick={() => {
                                        loadAllServicesWithTracksForQuarter(appSettings[currentStage].appId)
                                    }}>
                                        Refresh
                                    </Button>
                                    <Button iconName="download" onClick={() => {
                                        gridRef.current.api.exportDataAsExcel({
                                            fileName: `deliverables-${new Date().toISOString().split('T')[0]}.xlsx`,
                                            columnKeys: [...(alias_dropdown[currentStage] || []).map(a => `alias_${a.value}`), 'Process', 'deliverables', 'due_date',  'post_wb_due_date', 'post_tax_date', 'uploaders', 'reviewers', 'l8reviewers']
                                        })
                                    }}>
                                        Export
                                    </Button>
                                    {
                                        isAdmin.current && hasViewChanged && !preferenceButtonLoaderMessage && <Button variant='primary' onClick={() => { savePreference() }}>Save view</Button>
                                    }

                                    {
                                        isAdmin.current && !preferenceButtonLoaderMessage && <Button variant='inline-link' onClick={() => { resetView() }}>Reset view</Button>
                                    }
                                    {
                                        preferenceButtonLoaderMessage && <Spinner>{preferenceButtonLoaderMessage}</Spinner>
                                    }
                                    {/* <Button variant='primary' onClick={() => {
                                                setQuickFilterText('')
                                                resetGridView()
                                                loadAllServicesWithTracksForQuarter(appSettings[currentStage].appId)
                                            }}>
                                                Reset
                                            </Button> */}
                                </SpaceBetween>
                            <SpaceBetween direction='horizontal' size='s' >
                                <Box variant="awsui-key-label">View As:</Box>
                                <Select
                                    selectedOption={selectedAlias}
                                    onChange={({ detail }) => {
                                        setSelectedAlias(detail.selectedOption);
                                    }}
                                    options={[
                                        ...(isAdmin.current ? [{ label: "All", value: null }] : []),
                                        ...aliasOptions
                                    ]}
                                    placeholder="Select view"
                                />
                            </SpaceBetween>
                            </Grid>

                                        <Grid gridDefinition={[{ colspan: 10 }, { colspan: 2 }]}>
                                            <SpaceBetween direction='horizontal' size='xl'>
                                                <SpaceBetween direction='horizontal' size='m'>
                                                    <Box variant="awsui-key-label">Quick filters: </Box>
                                                    <Box>
                                                        <SegmentedControl
                                                            selectedId={quickFilterId}
                                                            onChange={({ detail }) =>
                                                                setQuickFilterId(detail.selectedId)
                                                            }
                                                            options={[
                                                                { text: "All", id: "all" }
                                                            ]}
                                                        />
                                                    </Box>
                                                </SpaceBetween>
                                                <SpaceBetween direction='horizontal' size='s'>
                                                    <Box> by status: </Box>
                                                    <SegmentedControl
                                                        selectedId={quickFilterId}
                                                        onChange={({ detail }) =>
                                                            setQuickFilterId(detail.selectedId)
                                                        }
                                                        options={[
                                                            { text: `Completed`, id: "completed" },
                                                            { text: 'Incomplete', id: "incomplete" },
                                                        ]}
                                                    />
                                                </SpaceBetween>
                                                <SpaceBetween direction='horizontal' size='s'>
                                                    <Box> for {userId}: </Box>
                                                    <SegmentedControl
                                                        selectedId={quickFilterId}
                                                        onChange={({ detail }) =>
                                                            setQuickFilterId(detail.selectedId)
                                                        }
                                                        options={[
                                                            { text: 'Preparer', id: "preparer" },
                                                            { text: 'Reviewer', id: "reviewer" },
                                                            { text: 'L8/Director Reviewer', id: "l8reviewer" }
                                                        ]}
                                                    />
                                                </SpaceBetween>
                                            </SpaceBetween>
                                            <Box display='flex' alignItems='center' justifyContent='flex-end'>
                                                    {isAdmin.current && (
                                                        <Button onClick={() => setShowUploadDeliverablesDueDateModal(true)} variant='primary'>Bulk Upload Deliverables Information</Button>
                                                    )}
                                            </Box>
                                    </Grid>

                                        <div style={{
                                            width: '100%',
                                            height: 'calc(100vh - 200px)',
                                        }}>
                                            <div
                                                className="ag-theme-alpine"
                                                style={{ width: "100%" }}
                                            >
                                                <AgGridReact
                                                    ref={gridRef}
                                                    rowData={deliverables}
                                                    popupParent={document.body}
                                                    loading={showDeliverablesLoader}
                                                    domLayout='autoHeight'
                                                    defaultColDef={defaultColDef}
                                                    groupDisplayType="groupRows"
                                                    groupDefaultExpanded={-1}
                                                    onGridReady={onGridReady}
                                                    onRowGroupOpened={onRowGroupOpened}
                                                    isExternalFilterPresent={isExternalFilterPresent}
                                                    doesExternalFilterPass={doesExternalFilterPass}
                                                    suppressScrollOnNewData={true}
                                                    suppressCellFocus={true}
                                                    columnDefs={[{
                                                        field: "group_name", rowGroup: true, hide: true,
                                                        valueFormatter: (params) => {
                                                            if (!params.value) return '';
                                                            // Conditional formatting because we dont have the functionality to map group name with the team(view as). 
                                                            if (params.value === 'SEC' && selectedAlias?.value != null) {
                                                                return 'Deliverables';
                                                            }
                                                            return params.value;
                                                        }
                                                    },
                                                    ...(selectedAlias?.value === null ? [
                                                        // When "All" is selected, show 3 separate columns for each alias
                                                        ...(aliasOptions.map((aliasOption, index) => ({
                                                            field: `alias_${aliasOption.value}`,
                                                            headerName: aliasOption.label,
                                                            width: index === 0 ? '300px' : '200px',
                                                            autoHeight: true,
                                                            sort: index === 0 ? 'asc' : null,
                                                            cellRenderer: (params) => {
                                                                const displayValue = getDisplayName(params, aliasOption, index)
                                                                return <Box>
                                                                    <SpaceBetween direction='horizontal' size='s'>
                                                                        {isAdmin.current && index === 0 ? <Button iconName="settings" variant="inline-icon" onClick={() => { params.data.flex_id ? setFlexicoConfig(params.data) : setConfigWindowJson(params.data) }} /> : <></>}
                                                                        <SpaceBetween direction='vertical'>
                                                                            <span className="small_values">{displayValue}</span>

                                                                            <SpaceBetween direction='horizontal' size='m'>
                                                                                {index === 0 && getTagForDeliverable(params?.data)?.['disabled'] && <span className="smaller_values grey_badge">Disabled</span>}
                                                                                {
                                                                                    index === 0 && isAnnualOnlyDeliverable(getTagForDeliverable(params?.data)?.['cadence']) ? <span className="info_message small_label">Annual only</span> :
                                                                                        <>
                                                                                            {
                                                                                                index === 0 && isAnnualDeliverable(getTagForDeliverable(params?.data)?.['cadence']) && <span className="info_message small_label">Annual</span>
                                                                                            }
                                                                                            {
                                                                                                index === 0 && isQuarterlyDeliverable(getTagForDeliverable(params?.data)?.['cadence']) && <span className="info_message small_label">Quarterly</span>
                                                                                            }
                                                                                        </>
                                                                                }

                                                                            </SpaceBetween>
                                                                            {
                                                                                index === 0 && <SpaceBetween direction='horizontal' size='m'>
                                                                                    {
                                                                                        params.data.flex_id && <span className="smaller_values info_message">Automated</span>
                                                                                    }
                                                                                    {
                                                                                        params.data.process_id && <Box>
                                                                                            {
                                                                                                params.data.environment && params.data.environment == 'Transfer_FAST_RedShift' ? <span className="smaller_values info_message">to Workiva</span> : <span className="smaller_values info_message">to Workdocs</span>
                                                                                            }
                                                                                        </Box>
                                                                                    }


                                                                                </SpaceBetween>
                                                                            }
                                                                        </SpaceBetween>
                                                                    </SpaceBetween>
                                                                </Box>
                                                            },
                                                            valueGetter: (params) => {
                                                                if (params.data == null) return '';
                                                                const displayValue = getDisplayName(params, aliasOption, index)
                                                                return displayValue.split(',')[0].trim();
                                                            },
                                                            getQuickFilterText: (params) => {
                                                                if (params.data == null) return '';
                                                                const displayValue = getDisplayName(params, aliasOption, index)
                                                                return [displayValue, ...getTagForDeliverable(params.data)?.filterOnlyTags || [], ...getTagForDeliverable(params.data)?.showTags || []].join(' ');
                                                            },
                                                            sortable: true,
                                                            resizable: true,
                                                        })))
                                                    ] : [
                                                        // When a specific alias is selected, show single column
                                                        {
                                                            field: 'Process',
                                                            headerName: 'Deliverable Reference',
                                                            width: '250px',
                                                            autoHeight: true,
                                                            sort: 'asc',
                                                            cellRenderer: (params) => {
                                                                // Always show template_name or process_name (backend handles alias logic)
                                                                const displayText = params.data.flex_id ? params.data[FLEXICO_TEMPLATE_KEYS.template_name] : params.data[PROCESS_KEYS.process_name];
                                                                const displayContent = <span className="small_values">{displayText}</span>;

                                                                return <Box>
                                                                    <SpaceBetween direction='horizontal' size='s'>
                                                                        {isAdmin.current ? <Button iconName="settings" variant="inline-icon" onClick={() => { params.data.flex_id ? setFlexicoConfig(params.data) : setConfigWindowJson(params.data) }} /> : <></>}
                                                                        <SpaceBetween direction='vertical'>
                                                                            {displayContent}
                                                                            <SpaceBetween direction='horizontal' size='m'>
                                                                                {getTagForDeliverable(params?.data)?.['disabled'] && <span className="smaller_values grey_badge">Disabled</span>}
                                                                                {
                                                                                    isAnnualOnlyDeliverable(getCadenceAttribute(params.data?.custom_attributes)) ? <span className="info_message small_label">Annual only</span> :
                                                                                        <>
                                                                                            {
                                                                                                isAnnualDeliverable(getCadenceAttribute(params.data?.custom_attributes)) && <span className="info_message small_label">Annual</span>
                                                                                            }
                                                                                            {
                                                                                                isQuarterlyDeliverable(getCadenceAttribute(params.data?.custom_attributes)) && <span className="info_message small_label">Quarterly</span>
                                                                                            }
                                                                                        </>
                                                                                }
                                                                            </SpaceBetween>

                                                                            <SpaceBetween direction='horizontal' size='m'>
                                                                                {
                                                                                    params.data.flex_id && <span className="smaller_values info_message">Automated</span>
                                                                                }
                                                                                {
                                                                                    params.data.process_id && <Box>
                                                                                        {
                                                                                            params.data.environment && params.data.environment == 'Transfer_FAST_RedShift' ? <span className="smaller_values info_message">to Workiva</span> : <span className="smaller_values info_message">to Workdocs</span>
                                                                                        }
                                                                                    </Box>
                                                                                }
                                                                            </SpaceBetween>
                                                                        </SpaceBetween>
                                                                    </SpaceBetween>
                                                                </Box>
                                                            },
                                                            valueGetter: (params) => {
                                                                if (params.data == null) {
                                                                    return ''
                                                                }
                                                                // Always use template_name or process_name for sorting/filtering
                                                                const displayText = params.data.flex_id ? (params.data[FLEXICO_TEMPLATE_KEYS.template_name] || "-") : (params.data[PROCESS_KEYS.process_name] || "-");
                                                                return [displayText, ...getTagForDeliverable(params.data)?.filterOnlyTags || [], ...getTagForDeliverable(params.data)?.showTags || []];

                                                            },
                                                            sortable: true,
                                                            resizable: true,
                                                        }
                                                    ]),
                                                    {
                                                        field: 'deliverables',
                                                        headerName: 'Title',
                                                        width: '300px',
                                                        cellRenderer: (params) => {
                                                            // Build the alias query parameter if an alias is selected (not "All")
                                                            let aliasParam = '';
                                                            if (selectedAlias && selectedAlias.value) {
                                                                const aliasValue = params.data.flex_id ? params.data[FLEXICO_TEMPLATE_KEYS.template_name] : params.data[PROCESS_KEYS.process_name];
                                                                aliasParam = `&alias=${aliasValue}&view_as=${selectedAlias.value}`;
                                                            }
                                                            const handleLinkClick = async (e) => {
                                                                e.preventDefault();

                                                                // Check if user has uploader access
                                                                const hasUploaderAccess = await checkUserUploaderAccess(params.data.uploaders);

                                                                let redirectPath;
                                                                if (hasUploaderAccess) {
                                                                    // Redirect to upload page
                                                                    if (params.data.flex_id) {
                                                                        redirectPath = `/App/${params.data.app_id}/flexico/${params.data.flex_id}/upload?back=CorpReportingHome${aliasParam}`;
                                                                    } else {
                                                                        redirectPath = `/App/${params.data.app_id}/process/${params.data.process_id}/upload?back=CorpReportingHome${aliasParam}`;
                                                                    }
                                                                } else {
                                                                    // Redirect to history page
                                                                    if (params.data.flex_id) {
                                                                        redirectPath = `/App/${params.data.app_id}/flexico/${params.data.flex_id}/history?back=CorpReportingHome${aliasParam}`;
                                                                    } else {
                                                                        redirectPath = `/App/${params.data.app_id}/process/${params.data.process_id}/history?back=CorpReportingHome${aliasParam}`;
                                                                    }
                                                                }

                                                                window.open(redirectPath, '_blank')
                                                            };

                                                            return (
                                                                    <Link href="#" onClick={handleLinkClick} variant="primary">
                                                                        <span className="small_values">{params.data.flex_id ? (params.data.label || "-") : (params.data[PROCESS_KEYS.label] || "-")}</span>
                                                                    </Link>
                                                            )
                                                        },
                                                        valueGetter: (params) => {
                                                            if (params.data == null) {
                                                                return ''
                                                            }
                                                            return params.data.flex_id ? (params.data.label || "-") : (params.data[PROCESS_KEYS.label] || "-");
                                                        },
                                                        sortable: true,
                                                        resizable: true
                                                    },
                                                    {
                                                        field: 'prewbstatus',
                                                        headerName: 'Pre-WB Status',
                                                        width: '250px',
                                                        cellRenderer: (params) => <>
                                                        {
                                                                params?.data?.no_pre_wb_due_date ?
                                                                    <Box><span className="small_values">{CRA_STATUS.NO_PRE_WB}</span></Box> :
                                                                    <SpaceBetween direction='horizontal'>
                                                                        {isAdmin.current && <Button iconName="edit" variant="icon" onClick={() => { editStatusInIntervalTracking('PreWB', params.data) }} />}
                                                                        {renderStatus(getStatus(params.data, getOneWBStatusBasedOnCustomAttributes(params.data, 'PreWB')), params.data.flex_id ? 'flexico' : 'frisco', isAdmin.current)}
                                                                    </SpaceBetween>
                                                        }
                                                        </>,
                                                        valueGetter: (params) => {
                                                            if (params?.data?.no_pre_wb_due_date) {
                                                                return [CRA_STATUS.NO_PRE_WB];
                                                            }
                                                            let status = getStatus(params.data, getOneWBStatusBasedOnCustomAttributes(params.data, 'PreWB'))
                                                            return [status.overall_status, status.current_status];
                                                        },
                                                        sortable: true,
                                                        resizable: true,
                                                        autoHeight: true,
                                                    },
                                                    {
                                                        field: 'due_date',
                                                        headerName: 'Pre-WB Due Date (Local Time)',
                                                        width: '250px',
                                                        cellRenderer: (params) => {
                                                            return params?.data?.no_pre_wb_due_date ?
                                                                <Box><span className="small_values">{CRA_STATUS.NO_PRE_WB}</span></Box> :
                                                                showDueDatesTable(getDueDates(params.data)?.due_date, getDueDates(params.data)?.due_time)
                                                        },
                                                        valueGetter: (params) => {
                                                            if (params?.data?.no_pre_wb_due_date) {
                                                                return [CRA_STATUS.NO_PRE_WB];
                                                            }
                                                            return [getDueDates(params.data)?.due_date];
                                                        },
                                                        sortable: true,
                                                        resizable: true
                                                    },
                                                    {
                                                        field: 'postwbstatus',
                                                        headerName: 'Post-WB Status',
                                                        width: '250px',
                                                        cellRenderer: (params) =>
                                                            <>
                                                                {
                                                                    params?.data?.no_post_wb_due_date ?
                                                                        <Box><span className="small_values">{CRA_STATUS.NO_POST_WB}</span></Box> :
                                                                        <SpaceBetween direction='horizontal'>
                                                                            {isAdmin.current && <Button iconName="edit" variant="icon" onClick={() => { editStatusInIntervalTracking('PostWB', params.data) }} />}
                                                                            {renderStatus(getStatusForMultipleStatus(params.data, getWBStatusBasedOnCustomAttributes(params.data, 'PostWB')), params.data.flex_id ? 'flexico' : 'frisco', isAdmin.current)}
                                                                        </SpaceBetween>
                                                                }
                                                            </>,
                                                        valueGetter: (params) => {
                                                            if (params?.data?.no_post_wb_due_date) {
                                                                return [CRA_STATUS.NO_POST_WB];
                                                            }
                                                            let status = getStatusForMultipleStatus(params.data, getWBStatusBasedOnCustomAttributes(params.data, 'PostWB'))
                                                            return [status.overall_status, status.current_status];
                                                        },
                                                        sortable: true,
                                                        resizable: true,
                                                        autoHeight: true,
                                                    },
                                                    {
                                                        field: 'post_wb_due_date',
                                                        headerName: 'Post-WB Due Date (Local Time)',
                                                        width: '250px',
                                                        cellRenderer: (params) => {
                                                            return params?.data?.no_post_wb_due_date ?
                                                                <Box><span className="small_values">{CRA_STATUS.NO_POST_WB}</span></Box> :
                                                                showDueDatesTable(
                                                                    getDueDates(params.data)?.post_wb_due_date,
                                                                    getDueDates(params.data)?.post_wb_due_time
                                                                );
                                                        },
                                                        valueGetter: (params) => {
                                                            if (params?.data?.no_post_wb_due_date) {
                                                                return [CRA_STATUS.NO_POST_WB];
                                                            }
                                                            return [getDueDates(params.data)?.post_wb_due_date];
                                                        },
                                                        sortable: true,
                                                        resizable: true
                                                    },
                                                    {
                                                        field: 'post_tax_date',
                                                        headerName: 'Post-Tax Due Date (Local Time)',
                                                        width: '250px',
                                                        cellRenderer: (params) => 
                                                            <>
                                                            {
                                                                params?.data?.no_post_tax_date ?
                                                                <Box><span className="small_values">No Post-Tax</span></Box> :
                                                                showDueDatesTable(getDueDates(params.data)?.post_tax_date, getDueDates(params.data)?.post_tax_time)
                                                            }
                                                            </>,
                                                        valueGetter: (params) => {
                                                            if (params?.data?.no_post_tax_date) {
                                                                return ['No Post-Tax'];
                                                            }
                                                            return [getDueDates(params.data)?.post_tax_date];
                                                        },
                                                        sortable: true,
                                                        resizable: true
                                                    },
                                                    {
                                                        field: 'uploaders',
                                                        headerName: 'Uploaders',
                                                        autoSize: true,
                                                        cellRenderer: (params) => renderAliases(getAliases(params.data, PROCESS_KEYS.uploaders, UPLOADER_TYPES.UPLOADER, UPLOADER_TYPES.UPLOADER_LDAP)),
                                                        sortable: true,
                                                        resizable: true,
                                                        autoHeight: true,
                                                        valueGetter: (params) => {
                                                            return flattenAliases(getAliases(params.data, PROCESS_KEYS.uploaders, UPLOADER_TYPES.UPLOADER, UPLOADER_TYPES.UPLOADER_LDAP));
                                                        },
                                                    },
                                                    {
                                                        field: 'reviewers',
                                                        headerName: 'Reviewers',
                                                        autoSize: true,
                                                        cellRenderer: (params) => renderAliases(getAliases(params.data, PROCESS_KEYS.approvers, APPROVER_TYPES.APPROVER, APPROVER_TYPES.APPROVER_LDAP, 0)),
                                                        sortable: true,
                                                        resizable: true,
                                                        autoHeight: true,
                                                        valueGetter: (params) => {
                                                            return flattenAliases(getAliases(params.data, PROCESS_KEYS.approvers, APPROVER_TYPES.APPROVER, APPROVER_TYPES.APPROVER_LDAP, 0));
                                                        },
                                                    },
                                                    {
                                                        field: 'l8reviewers',
                                                        headerName: 'Approvers',
                                                        autoSize: true,
                                                        cellRenderer: (params) => renderAliases(getAliases(params.data, PROCESS_KEYS.approvers, APPROVER_TYPES.APPROVER, APPROVER_TYPES.APPROVER_LDAP, 1)),
                                                        sortable: true,
                                                        resizable: true,
                                                        autoHeight: true,
                                                        valueGetter: (params) => {
                                                            return flattenAliases(getAliases(params.data, PROCESS_KEYS.approvers, APPROVER_TYPES.APPROVER, APPROVER_TYPES.APPROVER_LDAP, 1));
                                                        },
                                                    },
                                                    {
                                                        field: 'lastUpdated',
                                                        headerName: 'Last updated',
                                                        autoSize: true,
                                                        cellRenderer: (params) => showGenericDatesTable(getLatestTrackingDetails(params.data)?.last_updated_time_stamp),
                                                        sortable: true,
                                                        resizable: true,
                                                        autoHeight: true,
                                                        valueGetter: (params) => {
                                                            return convertToPST(getLatestTrackingDetails(params.data)?.last_updated_time_stamp)
                                                        }
                                                    },
                                                    ]}
                                                    rowSelection='single'
                                                    animateRows={true}
                                                    enableCellTextSelection={true}
                                                    onColumnVisible={handleGridViewChanges}
                                                    onColumnResized={handleGridViewChanges}
                                                    onColumnMoved={handleGridViewChanges}
                                                    onColumnPinned={handleGridViewChanges}
                                                    onSortChanged={handleGridViewChanges}
                                                    getRowId={getRowId}                                                
                                                    >
                                                </AgGridReact>
                                            </div>

                                        </div>

                                    </SpaceBetween>
                                </Box>
                </SpaceBetween>

                {flexicoConfig && (
                    <FlexicoConfig
                        config={flexicoConfig}
                        flexicoConfig={flexicoConfig}
                        windowContentLoadingMessage={windowContentLoadingMessage}
                        windowContentLoadingError={windowContentLoadingError}
                        setFlexicoConfig={setFlexicoConfig}
                        onCancel={() => setFlexicoConfig(null)}
                        getEpoch={getEpoch}
                        loadFlexicoDeliverables={() => { loadAllServicesWithTracksForQuarter(appSettings[currentStage].appId) }}
                        addOrreplace={addOrreplace}
                        getDueDates={getDueDates}
                        populateDueDateAttributeObject={populateDueDateAttributeObject}
                        dueDateKeys={due_date_keys}
                        userId={userId}
                    />
                )}
                {
                    configurationWindowContent ?
                        <Modal
                            onDismiss={() => resetModal()}
                            visible={configurationWindowContent}
                            footer={
                                <Box float="right">
                                    <SpaceBetween direction="horizontal" size="xs">
                                        {
                                            windowContentLoadingMessage ?
                                                <Box><Spinner></Spinner>{windowContentLoadingMessage}</Box> : ''
                                        }
                                        {
                                            windowContentLoadingError?
                                                <StatusIndicator type="error">{windowContentLoadingError}</StatusIndicator> : ''
                                        }
                                        <Button variant="link" onClick={() => resetModal()}>Cancel</Button>
                                        <Button variant="primary" onClick={() => saveControlPanelDetails()} disabled={windowContentLoadingMessage} >Save</Button>
                                    </SpaceBetween>
                                </Box>
                            }
                            header={`Control panel - ${configurationWindowContent && configurationWindowContent.hasOwnProperty(PROCESS_KEYS.label) ? configurationWindowContent[PROCESS_KEYS.label] : ''}`}
                            size='large'
                        >
                            <div className='craControlPanel'>
                            <Container >
                                <ColumnLayout columns={2}>
                                    <Box>Re-upload input</Box>
                                    <SpaceBetween direction='horizontal' size="s">
                                        <Box>
                                            {getQuarter()}
                                        </Box>
                                        <Button variant="primary" onClick={() => { resetStatus(configurationWindowContent) }}>Reset</Button>

                                        {
                                            resetLoadingMessage ? <Box float='center'> {resetLoadingMessage}</Box> : ''
                                        }
                                    </SpaceBetween>
                                </ColumnLayout>

                                <hr class="rounded"></hr>
                                <ColumnLayout columns={2}>
                                    <Box>Workstream</Box>
                                    <Select
                                        selectedOption={workstreamOptions.find(option => option.value === configurationWindowContent?.group_id?.toString()) || null}
                                        onChange={({ detail }) => {
                                            configurationWindowContent['group_id'] = detail.selectedOption?.value;
                                            setConfigurationWindowContent({ ...configurationWindowContent });
                                        }}
                                        options={workstreamOptions}
                                        placeholder="Select workstream"
                                    />
                                </ColumnLayout>
                                <hr class="rounded"></hr>

                                <ColumnLayout columns={2}>
                                    <Box>Tick to disable this deliverable</Box>
                                    <Checkbox
                                            onChange={({ detail }) => {
                                                configurationWindowContent['disabled'] = detail.checked.toString()
                                                setConfigurationWindowContent({ ...configurationWindowContent })
                                            }}
                                            checked={JSON.parse(configurationWindowContent['disabled'] || "false")}
                                        >
                                            
                                        </Checkbox>
                                </ColumnLayout>
                                <hr class="rounded"></hr>
                                <ColumnLayout columns={2}>
                                    <Box>Pre-WB Due Date</Box>
                                    <SpaceBetween direction='horizontal' size="s">
                                        <DatePicker
                                            onChange={({ detail }) => {
                                                configurationWindowContent['due_date'] = detail.value
                                                setConfigurationWindowContent({ ...configurationWindowContent })
                                            }}
                                            value={configurationWindowContent['due_date']}
                                            openCalendarAriaLabel={selectedDate =>
                                            (selectedDate
                                                ? `, selected date is ${selectedDate}`
                                                : "")
                                            }
                                            placeholder="YYYY-MM-DD"
                                            disabled={JSON.parse(configurationWindowContent['no_pre_wb_due_date'] || "false")}
                                        />
                                        <TimeInput
                                            onChange={({ detail }) => {
                                                configurationWindowContent['due_time'] = detail.value
                                                setConfigurationWindowContent({ ...configurationWindowContent })
                                            }}
                                            value={configurationWindowContent['due_time']}
                                            format="hh:mm"
                                            placeholder="hh:mm"
                                            disabled={JSON.parse(configurationWindowContent['no_pre_wb_due_date'] || "false")}
                                        />
                                        <Checkbox
                                            onChange={({ detail }) => {
                                                configurationWindowContent['no_pre_wb_due_date'] = detail.checked.toString()
                                                if (detail.checked) {
                                                    configurationWindowContent['due_date'] = ''
                                                    configurationWindowContent['due_time'] = ''
                                                } else {
                                                    configurationWindowContent['due_date'] = configurationWindowContentOriginal['due_date']
                                                    configurationWindowContent['due_time'] = configurationWindowContentOriginal['due_time']
                                                }
                                                setConfigurationWindowContent({ ...configurationWindowContent })
                                            }}
                                            checked={JSON.parse(configurationWindowContent['no_pre_wb_due_date'] || "false")}
                                        >
                                            No Pre WB
                                        </Checkbox>

                                    </SpaceBetween>
                                </ColumnLayout>
                                <hr class="rounded"></hr>
                                <ColumnLayout columns={2}>
                                    <Box>Post-WB Due Date</Box>
                                    <SpaceBetween direction='horizontal' size="s">
                                        <DatePicker
                                            onChange={({ detail }) => {
                                                configurationWindowContent['post_wb_due_date'] = detail.value
                                                setConfigurationWindowContent({ ...configurationWindowContent })
                                            }}
                                            value={configurationWindowContent['post_wb_due_date']}
                                            openCalendarAriaLabel={selectedDate =>
                                            (selectedDate
                                                ? `, selected date is ${selectedDate}`
                                                : "")
                                            }
                                            placeholder="YYYY-MM-DD"
                                            disabled={JSON.parse(configurationWindowContent['no_post_wb_due_date'] || "false")}
                                        />
                                        <TimeInput
                                            onChange={({ detail }) => {
                                                configurationWindowContent['post_wb_due_time'] = detail.value
                                                setConfigurationWindowContent({ ...configurationWindowContent })
                                            }}
                                            value={configurationWindowContent['post_wb_due_time']}
                                            format="hh:mm"
                                            placeholder="hh:mm"
                                            disabled={JSON.parse(configurationWindowContent['no_post_wb_due_date'] || "false")}
                                        />
                                        <Checkbox
                                            onChange={({ detail }) => {
                                                configurationWindowContent['no_post_wb_due_date'] = detail.checked.toString()
                                                if (detail.checked) {
                                                    configurationWindowContent['post_wb_due_date'] = ''
                                                    configurationWindowContent['post_wb_due_time'] = ''
                                                } else {
                                                    configurationWindowContent['post_wb_due_date'] = configurationWindowContentOriginal['post_wb_due_date']
                                                    configurationWindowContent['post_wb_due_time'] = configurationWindowContentOriginal['post_wb_due_time']
                                                }
                                                setConfigurationWindowContent({ ...configurationWindowContent })
                                            }}
                                            checked={JSON.parse(configurationWindowContent['no_post_wb_due_date'] || "false")}
                                        >
                                            No Post WB
                                        </Checkbox>
                                    </SpaceBetween>
                                </ColumnLayout>
                                <hr class="rounded"></hr>
                                <ColumnLayout columns={2}>
                                    <Box>Post-Tax Due Date</Box>
                                    <SpaceBetween direction='horizontal' size="s">
                                        <DatePicker
                                            onChange={({ detail }) => {
                                                configurationWindowContent['post_tax_date'] = detail.value
                                                setConfigurationWindowContent({ ...configurationWindowContent })
                                            }}
                                            value={configurationWindowContent['post_tax_date']}
                                            openCalendarAriaLabel={selectedDate =>
                                            (selectedDate
                                                ? `, selected date is ${selectedDate}`
                                                : "")
                                            }
                                            placeholder="YYYY-MM-DD"
                                            disabled={JSON.parse(configurationWindowContent['no_post_tax_date'] || "false")}
                                        />
                                        <TimeInput
                                            onChange={({ detail }) => {
                                                configurationWindowContent['post_tax_time'] = detail.value
                                                setConfigurationWindowContent({ ...configurationWindowContent })
                                            }}
                                            value={configurationWindowContent['post_tax_time']}
                                            format="hh:mm"
                                            placeholder="hh:mm"
                                            disabled={JSON.parse(configurationWindowContent['no_post_tax_date'] || "false")}
                                        />
                                        <Checkbox
                                            onChange={({ detail }) => {
                                                configurationWindowContent['no_post_tax_date'] = detail.checked.toString()
                                                if (detail.checked) {
                                                    configurationWindowContent['post_tax_date'] = ''
                                                    configurationWindowContent['post_tax_time'] = ''
                                                } else {
                                                    configurationWindowContent['post_tax_date'] = configurationWindowContentOriginal['post_tax_date']
                                                    configurationWindowContent['post_tax_time'] = configurationWindowContentOriginal['post_tax_time']
                                                }
                                                setConfigurationWindowContent({ ...configurationWindowContent })
                                            }}
                                            checked={JSON.parse(configurationWindowContent['no_post_tax_date'] || "false")}
                                        >
                                            No Post Tax
                                        </Checkbox>
                                    </SpaceBetween>
                                </ColumnLayout>
                                <hr class="rounded"></hr>
                                <ColumnLayout columns={2}>
                                    <Box>Cadence</Box>
                                    <RadioGroup
                                        onChange={({ detail }) => {
                                            configurationWindowContent['cadence'] = detail.value
                                            setConfigurationWindowContent({ ...configurationWindowContent })
                                        }}
                                        value={configurationWindowContent['cadence']}
                                        items={[
                                            { value: "QUARTERLY", label: "Quarterly" },
                                            { value: "ANNUALLY", label: "Annual only" },
                                            { value: "BOTH", label: "Both" },
                                        ]}
                                    />
                                </ColumnLayout>
                                <hr class="rounded"></hr>
                                <ColumnLayout columns={2}>
                                    <Box>Uploaders</Box>
                                    <CustomMultiHybridInputAndSelect field={PROCESS_KEYS.uploaders}
                                        inputKey={PROCESS_KEYS.UPLOADER_KEYS.alias} selectKey={PROCESS_KEYS.UPLOADER_KEYS.type} selectHint="Choose type"
                                        placeholder="alias" getValues={getValue} postProcess={postProcessTeamEmails} validator={approversValidation}
                                        updateValueWithFilterCriteria={updateValue} getOptions={getSelectFieldValues} info=' ' errorMessage='type and alias input are mandatory' duplicatesNotAllowed={true}
                                        loginOptions={suggestedLogins} getLoginOptions={getSuggestedLoginsCaller} aliasesLoading={aliasesLoading} />
                                </ColumnLayout>
                                <hr class="rounded"></hr>
                                <ColumnLayout columns={2}>
                                    <Box>Reviewers</Box>
                                    <CustomMultiHybridInputAndSelect field={PROCESS_KEYS.approvers}
                                        inputKey={PROCESS_KEYS.APPROVER_KEYS.alias} selectKey={PROCESS_KEYS.APPROVER_KEYS.type} selectHint="Choose type"
                                        placeholder="alias" getValues={getValue} filterCriteria={{ column_index: 0 }} postProcess={postProcessTeamEmails} validator={approversValidation} indexKey={PROCESS_KEYS.APPROVER_KEYS.column_index} defIndex={0}
                                        updateValueWithFilterCriteria={updateValue} getOptions={getSelectFieldValues} info=' ' errorMessage='type and alias input are mandatory' duplicatesNotAllowed={true}
                                        loginOptions={suggestedLogins} getLoginOptions={getSuggestedLoginsCaller} aliasesLoading={aliasesLoading} />
                                </ColumnLayout>
                                <hr class="rounded"></hr>
                                <ColumnLayout columns={2}>
                                    <Box>Approvers (L8 Directors)</Box>
                                    <CustomMultiHybridInputAndSelect field={PROCESS_KEYS.approvers}
                                        inputKey={PROCESS_KEYS.APPROVER_KEYS.alias} selectKey={PROCESS_KEYS.APPROVER_KEYS.type} selectHint="Choose type"
                                        placeholder="alias" getValues={getValue} filterCriteria={{ column_index: 1 }} postProcess={postProcessTeamEmails} validator={approversValidation} indexKey={PROCESS_KEYS.APPROVER_KEYS.column_index} defIndex={1}
                                        updateValueWithFilterCriteria={updateValue} getOptions={getSelectFieldValues} info=' ' errorMessage='type and alias input are mandatory' duplicatesNotAllowed={true}
                                        loginOptions={suggestedLogins} getLoginOptions={getSuggestedLoginsCaller} aliasesLoading={aliasesLoading} />
                                </ColumnLayout>
                                <hr class="rounded"></hr>
                                <br />
                                <ColumnLayout columns={2}>
                                    <Box>Mandatory Supporting Files</Box>
                                    <Multiselect
                                        options={mandatoryFields}
                                        placeholder="Select the mandatory supporting files to be uploaded"
                                        checkboxes={true}
                                        selectedOptions={configurationWindowContent['mandatoryDocuments'] || []}
                                        onChange={({ detail }) => {
                                            configurationWindowContent['mandatoryDocuments'] = detail?.selectedOptions
                                            setConfigurationWindowContent({ ...configurationWindowContent })
                                        }}
                                        keepOpen={true}
                                        filteringType="auto"
                                    ></Multiselect>
                                </ColumnLayout>
                                <hr class="rounded"></hr>

                                <br />

                                {/* Dynamic Deliverables Section */}
                                <SpaceBetween direction='vertical' size='m'>
                                    <SpaceBetween direction='horizontal' size='s' alignItems='center'>
                                        <Box variant="h3">Deliverable References</Box>
                                        <Button
                                            iconName="add-plus"
                                            variant="normal"
                                            onClick={addDeliverable}
                                        >
                                            Add Reference
                                        </Button>
                                    </SpaceBetween>

                                    {/* Column Headers */}
                                    <ColumnLayout columns={2}>
                                        <Box variant="awsui-key-label">Team</Box>
                                        <Box variant="awsui-key-label">Reference</Box>
                                    </ColumnLayout>

                                    {/* Dynamic Deliverable Items */}
                                    {dynamicDeliverables.map((deliverable, index) => (
                                        <div key={deliverable.id}>
                                            <ColumnLayout columns={2}>
                                                <Select
                                                    selectedOption={aliasOptions.find(option => option.label === deliverable.label) || null}
                                                    onChange={({ detail }) => {
                                                        updateDeliverableLabel(deliverable.id, detail.selectedOption.label);
                                                    }}
                                                    options={aliasOptions.filter(option =>
                                                        !dynamicDeliverables.some(d => d.label === option.label && d.id !== deliverable.id)
                                                    )}
                                                    placeholder="Select label"
                                                />
                                                <SpaceBetween direction='horizontal' size='l' alignItems='center'>
                                                    <Input
                                                        value={configurationWindowContent[`${deliverable.id}_deliverable`] || ''}
                                                        onChange={({ detail }) => {
                                                            const updated = { ...configurationWindowContent };
                                                            updated[`${deliverable.id}_deliverable`] = detail.value;
                                                            setConfigurationWindowContent(updated);
                                                        }}
                                                        placeholder="REF1.1"
                                                    />
                                                    <Button
                                                        iconName="remove"
                                                        variant="icon"
                                                        onClick={() => removeDeliverable(deliverable.id)}
                                                    />
                                                </SpaceBetween>
                                            </ColumnLayout>
                                        </div>
                                    ))}
                                </SpaceBetween>
                                <br />
                            </Container>
                            </div>
                        </Modal> : <></>
                }
                {
                    adminStatusEditContentModal && <Modal
                        onDismiss={() => resetAdminStatusEditModal()}
                        visible={adminStatusEditContentModal}
                        footer={
                            <Box float="right">
                                <SpaceBetween direction="horizontal" size="xs">
                                    {
                                        adminStatusEditContentModalLoader ?
                                            <Box><Spinner></Spinner>{adminStatusEditContentModalLoader}</Box> : ''
                                    }
                                    <Button variant="link" onClick={() => resetAdminStatusEditModal()}>Cancel</Button>
                                    <Button variant="primary" onClick={() => alterIntervalTrackingStatus()} disabled={adminStatusEditContentModalLoader} >Save</Button>
                                </SpaceBetween>
                            </Box>
                        }
                        header={<>{adminStatusEditContentModal.type == 'FRISCO' ? adminStatusEditContentModal.data.process_name : adminStatusEditContentModal.template_name} - {adminStatusEditContentModal.wb_type}</>}
                    >
                        <SpaceBetween direction='vertical' size='xl'>
                            <SpaceBetween direction='horizontal' size='m'>
                                <Box>Current status : </Box>
                                {renderStatusWithLastUpdatedTime(adminStatusEditContentModal.status, adminStatusEditContentModal?.data?.flex_id ? 'flexico' : 'frisco', isAdmin.current)}
                            </SpaceBetween>

                            <SpaceBetween direction='horizontal' size='m'>
                                <Box>Changing to : </Box>
                                <Select
                                    selectedOption={{ 'label': adminStatusEditContentModal.status.overall_status, 'value': adminStatusEditContentModal.status.overall_status }}
                                    onChange={({ detail }) => {
                                        adminStatusEditContentModal.status.overall_status = detail.selectedOption.value
                                        setAdminStatusEditContentModal({ ...adminStatusEditContentModal })
                                    }

                                    }
                                    options={overallStatusOptions}
                                />
                                <Select
                                    selectedOption={{ 'label': adminStatusEditContentModal.status.current_status, 'value': adminStatusEditContentModal.status.current_status }}
                                    onChange={({ detail }) => {
                                        adminStatusEditContentModal.status.current_status = detail.selectedOption.value
                                        setAdminStatusEditContentModal({ ...adminStatusEditContentModal })
                                    }
                                    }
                                    options={adminStatusEditContentModal?.data?.flex_id ? flexicoStatusOptions[adminStatusEditContentModal.wb_type] : friscoStatusOptions[adminStatusEditContentModal.wb_type]}
                                />
                            </SpaceBetween>
                        </SpaceBetween>
                    </Modal>
                }


                <br />

                <br />
                {/* <Feedback appId={appSettings[currentStage].appId} pageId="corpReportingDeliverablesHome" userId={userId} parentId={"null"} level={0} limit={1}></Feedback> */}

            </ContentLayout> : <Box>
                <Spinner></Spinner>
                Loading...
            </Box>
    )


    return (
        <AppLayout
            disableContentPaddings={true}
            content={Content}
            contentType="default"
            navigationOpen={NavOpen}
            navigation={<SideNav activeHref={`/CorpReportingHome/deliverables`} id={appSettings[currentStage].appId} isAdmin={isAdmin.current} />}
            onNavigationChange={() => {
                setNavOpen(!NavOpen);
            }}
            toolsHide={true}
        />
    );
};
